import TableView from '@nile/banyan/src/Pages/ServiceCatalog/TableView';
import {
  getType,
  isEditable,
  isFilterable,
  isBold,
  getWidth,
  getAccessor
} from '@nile/client_management/src/Pebbles/InvoiceDetails';
import {
  AccessControl,
  B1,
  ContentDeciderContainer,
  getTranslatedText,
  TableLoading,
  BackgroundIcon,
  AppContext,
  getDownloadURL,
  ALL_MODULES,
  HourGlassLoader,
  TableContainer,
  Tag,
  B3T2,
  toast,
  DeleteModal,
  QUOTE_STATUS,
  getParsedCrudData,
  ListInfoBanner,
  BrandingLogo,
  TEXT_LENGTH,
  isAuthorised,
  formatDataForSelectDropdown,
  DropdownIndicator,
  formatGroupLabel,
  IndicatorSeparator,
  SkeletonTableLoading,
  CustomModal,
  useIsAuthorisedHook,
  DateTimeFormatter,
  getHeaderValue,
  preFormatForm,
  TAB_PAGES,
  INVOICE_STATUS,
  useUserMSPCheckHook,
  validateForm,
  quoteConstraints,
  NoDataCard,
  DateTimePicker,
  InvoiceQuoteLoader,
  StateCountryLabel,
  useActivityTracker,
  TAX_ROUND_OFF,
  sideConversationPricingPlans,
  CurrencyText,
  calculateTermAndDueDate,
  useCheckFeatureGating,
  fetchApi,
  getConversationOrder,
  DisabledTag,
  Loader
} from '@nile/components';
import AdditionalPropertiesHolder from '@nile/client_management/src/Components/AdditionalProperties.tsx';
import FixedPositionActionsGroup from '@nile/client_management/src/Components/FixedPositionActionsGroup.tsx';
import TabContext from '@nile/mangifera/src/Contexts/TicketContext';
import { EmailEditor } from '@nile/banyan/src/Components/Editors';
import { getTabId } from '@nile/mangifera/src/Pebbles/TabManager';
import {
  Button,
  TextField,
  Dropdown,
  Sheet,
  Heading,
  Page,
  ButtonGroup,
  TextStyle
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { CurrencyField } from '@nile/components/src/Utils/CurrencyText';
import {
  AccountClient,
  UPDATE_INVOICE,
  DELETE_INVOICE,
  GET_INTEGRATIONS_BY_IDS,
  GET_SEND_AND_INTEGRATION_STATUS,
  PUSH_INVOICE,
  SEND_INVOICES,
  GET_ALL_TAX,
  GET_QUOTE,
  UPDATE_QUOTE,
  useLazyQuery as customUseLazyQuery,
  CREATE_QUOTE,
  GET_QUOTE_VERSIONS,
  GET_QUOTE_EVENTS,
  APPROVE_OR_REJECT_QUOTE,
  CREATE_INVOICE_FROM_QUOTE,
  DELETE_QUOTE,
  GET_GLOBAL_INVOICE_TEMPLATE,
  GET_QUOTE_CONFIG,
  GET_ENTITY_PROPERTIES,
  FETCH_INVOICE_CONFIGURATION
} from '@nile/graphql';
import envConfig from '@nile/home/src/Config/env';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import Loading from '@nile/components/src/Svg/AnimatedSvg/Loading.svg';
import TicketContext from '@nile/mangifera/src/Contexts/TicketContext';
import {
  isEmpty,
  includes,
  isEqual,
  omit,
  cloneDeep,
  pick,
  clamp
} from 'lodash';
import React, {
  useContext,
  useEffect,
  useRef,
  useState,
  useCallback,
  useMemo
} from 'react';
import { FormattedMessage, injectIntl, IntlProvider } from 'react-intl';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { useMutation, useQuery, useLazyQuery } from '@apollo/client';
import InvoiceErrors from '@nile/client_management/src/Components/InvoiceErrors';
import { getTotalValue } from '@nile/banyan/src/Pebbles/tax';
import { DataGetter } from '@nile/components/src/Containers/Worklog/utils';
import { SizeMe } from 'react-sizeme';
import dayjs from 'dayjs';
import DOMPurify from 'dompurify';
import InvoiceStatusCell from '@nile/client_management/src/Pages/Protected/ClientNavigation/InvoiceStatusCell';
import QuoteConversations from '@nile/client_management/src/Pages/Quote/QuoteConversations';
import ItemsToInvoice from '@nile/client_management/src/Pages/Invoice/ItemsToInvoice';
import VersionContainer from '@nile/client_management/src/Pages/Quote/VersionContainer';
import ContentVerification from '@nile/client_management/src/Pages/Quote/ContentVerification';
import QuoteActionPopup from '@nile/client_management/src/Pages/Quote/QuoteActionPopup';
import { defaultLayoutConfigObj } from '@nile/banyan/src/Constants/defaultLayoutConfig';
import { renderToStaticMarkup } from 'react-dom/server';
import {
  dompurifier,
  downloadHack,
  getEntityAttributes,
  roundToFixed,
  sanitizeWhiteSpace
} from '@nile/components/src/Utils/helpers';
import { quoteDefaultColumnCells as defaultColumnCells } from '@nile/client_management/src/Pages/Invoice/Utils/cells';
import { pdfStyles } from './Utils/index';
import TableForPrint from './TableForPrint';
import {
  findItemOrderDiff,
  getDragHandleColumnProps,
  getTaxLabel,
  reorderItems,
  sortItems
} from '../Invoice/Utils';
import {
  calculateData,
  updateProperties as updatePropertiesHelper,
  configureTableColumns,
  getAdditionalDiscount,
  getSubTotal,
  getTaxes,
  generateInvoiceOrQuoteSummaryRows,
  checkRowHighlightHelper,
  usePdfDownloader,
  onRowItemDragEnd
} from '@nile/client_management/src/Utils/invoiceAndQuoteHelper';
import { GET_FIELDS } from '@nile/banyan/src/Graphql/Mutations/ticket';

const DISCOUNT_TYPE = {
  AMOUNT: 'AMOUNT',
  PERCENT: 'PERCENT'
};

const SheetWrapper = styled.div`
  height: 100vh;
  width: 600px;
  background: #fff;
  // overflow: auto;
  .container-tabs {
    -ms-overflow-style: none;
    scrollbar-width: none;
    ::-webkit-scrollbar {
      display: none;
    }
  }
`;

const ChatWrapper = styled.div`
  min-width: 550px;
  height: 100%;
  max-width: 700px;
  width: 560px;
  border: 1px solid var(--sops-trans-white-border);
  .container-tabs {
    -ms-overflow-style: none;
    scrollbar-width: none;
    ::-webkit-scrollbar {
      display: none;
    }
  }
  .Superops-Tabs__Wrapper {
    border-radius: 10px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    box-shadow: none !important;
  }
`;

const LoadingWrapper = styled.div`
  svg {
    height: 80px;
    width: 80px;
  }
`;
const Wrapper = styled.div`
  .Polaris-Page {
    max-width: ${(props) =>
      props?.isAdditionalPropertiesVisible
        ? 'calc(100% - 960px) !important'
        : props.isChatVisible
        ? 'calc(100% - 560px) !important'
        : '1400px'};
    width: ${(props) => (props.isChatVisible ? '100%' : '1400px')};
  }
  .Polaris-Page-Header {
    padding: 20px !important;
  }
  .Superops-Page {
    max-width: ${(props) =>
      props?.isAdditionalPropertiesVisible
        ? 'calc(100% - 960px) !important'
        : props.isChatVisible
        ? 'calc(100% - 560px) !important'
        : '1400px'};
    width: ${(props) => (props.isChatVisible ? '100%' : 'inherit')};
  }
  .Superops-Page-Header {
    padding: 20px !important;
  }
  .Superops-Page__Content,
  .Superops-Page--contentPrimary {
    padding: 20px 0 !important;
  }
  .Superops-Heading .Superops-Heading--sizePrimary {
    font-size: 20px !important;
  }
  .Superops-TextField__ActionableSuffix {
    background: ${(props) =>
      props.clicked ? '#fffae4' : 'rgba(0, 0, 0, 0.05)'};
    border-radius: 10px 10px 0 0;
    transition: background 200ms linear;
  }
  .colHeader {
    padding-left: 8px;
  }
  .Superops-TextField__Input {
    border-bottom: 1px solid #ececec;
  }
  .Superops-Connected {
    padding-top: 0 !important;
  }
  .Superops-TextField__Input {
    min-height: 38px;
  }
  .Superops-TextField__Input {
    padding-left: 4px;
  }
  .Superops-Banner__Position {
    width: 100%;
  }
  .red {
    color: red;
  }
  .sk-table-container {
    height: 400px !important;
  }
  .branding-logo {
    margin-bottom: 10px !important;
  }
  .msp-name {
    font-size: 18px !important;
    // margin-left: 10px;
    font-weight: 600;
  }
  .invoice-title {
    font-weight: 600;
    font-size: 20px !important;
  }
`;

const Header = styled.div`
  display: flex;
  .invoice-title {
    font-weight: 600;
    font-size: 20px !important;
  }
  .Superops-TextField__Input {
    font-weight: 600;
    font-size: 20px !important;
  }
  .status-tag {
    height: 38px;
    min-width: fit-content;
  }
`;
const ClientInfo = styled.div`
  margin-bottom: 10px;
  .site-info {
    line-height: 21px;
  }

  [data-id='entityAttribute.client.name'],
  [data-id='attribute.msp.name'],
  [data-id='entityAttribute.site.name'] {
    font-size: 20px;
    font-weight: 600;
  }
`;

const DateSection = styled.div`
  .react-datepicker-wrapper,
  .react-datepicker__input-container > input {
    width: auto;
  }
`;

const PageHeader = styled.div`
  padding: ${(props) => (props.restrictActions ? '' : '20px 20px')};
  border-bottom: 1px solid var(--sops-trans-white-border);
  .module-logo {
    height: 45px !important;
    width: 45px !important;
  }
  .invoice-page-heading {
    font-size: 24px !important;
  }
`;
const ContentWrap = styled.div`
  height: ${(props) => (props?.restrictActions ? '100%' : 'calc(100% - 97px)')};
  .content-padding {
    padding: 0 20px !important;
  }
  .Superops-Page {
    display: flex;
    flex-direction: column;
  }
  .Superops-Page__Content {
    flex: 1;
  }
`;

const MemoGetter = styled(DataGetter)`
  background: transparent;
  border: 1px solid #ececec;
  border-radius: 10px;
  .Superops-Connected,
  .Superops-TextField {
    height: 100%;
  }
  textarea {
    height: 100% !important;
    font-weight: normal !important;
  }
`;

const DisplayMemo = styled(DataGetter)`
  border: 1px solid #ececec;
  background: none;
  border-radius: 10px;
  border: none !important;
  padding: 0px 15px;
  min-height: 38px;
  display: flex;
  flex-grow: 1;
  textarea {
    font-weight: normal !important;
  }
  .Superops-TextField__Input:disabled,
  .Superops-TextField--variantOutline > input:disabled,
  .Superops-TextField--variantOutline {
    background-color: transparent !important;
    cursor: auto !important;
  }
`;

const EditorHolder = styled.div`
  // height: 400px;
  // padding: 20px;
  margin: 20px;
  border: 1px solid #ececec;
  border-radius: 10px;
  #quill-rt-editor {
    height: 100%;
    .quill {
      min-height: 200px;
      .ql-container {
        border: none;
        min-height: inherit;
        .ql-editor {
          min-height: inherit;
        }
      }
    }
    .ql-toolbar {
      border: none;
    }
  }
`;

const QuoteLogo = styled.span`
  svg {
    height: 50px;
    width: 50px;
  }
`;

const InvoiceTitleEdit = styled.div`
  height: 40px;
  max-width: 80vw;
  position: relative;
  width: fit-content;
  .hidden-div {
    font-size: 20px !important;
    font-weight: 600;
    height: 0px;
    max-width: 100%;
    min-width: 300px;
    padding-left: 10px;
    white-space: nowrap;
    width: fit-content;
    visibility: hidden;
  }
  .Superops-Connected {
    max-width: 100%;
    min-width: 300px;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
`;

const PrimaryHeader = styled.div`
  padding: 0 20px 20px 20px;
  .Superops-TextField__Input {
    line-height: 40px !important;
    font-size: 20px !important;
    border-bottom: none;
  }
  .Superops-TextField__Backdrop {
    border: none !important;
  }
`;

const SignatureDisplayContainer = styled.div`
  font-size: 60px;
  font-weight: 700;
  padding: 9px 15px;
  line-height: 40px;
  min-height: 100px;
  line-break: anywhere;

  font-family: 'Qwitcher Grypen', cursive;

  &.empty {
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
      'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
      'Helvetica Neue', sans-serif;
    color: #a3a3a3;
  }
`;

const printDataRef = React.createRef();

const invoiceNode = React.createRef();

// const invoiceWorker = new Worker('./Workers/invoiceEditCalculations.js');

const dataQueue = [];
let currentProcessRunning = false;

let invoicePdfLoaderTimeout;

function QuoteDetailsContainer(props) {
  const { intl, match } = props;
  const { id } = match.params;
  const quoteId =
    props.quoteId || (match?.params?.viewtype === 'quoteList' ? id : null);
  return <QuoteDetails key={quoteId} {...props} />;
}

function QuoteDetails(props) {
  const { intl, match } = props;
  const params = new URLSearchParams(props.location.search);
  const isSendQuote = params.get('send');
  const tabContext = useContext(TabContext);
  const appContext = useContext(AppContext);
  const currentUser = appContext?.user || {};
  const planId = currentUser?.chargeBeePlanId?.toLowerCase();
  const clientCustomFieldsRef = useRef([]);
  const isConversationViewAuthorised = useIsAuthorisedHook(
    'clientConversation.view'
  );
  const isQuoteCustomFieldsAuthorised = useIsAuthorisedHook(
    'billingCustomFields.view'
  );
  const isClientCustomFieldsAuthorised = useIsAuthorisedHook(
    'clientCustomFields.view'
  );
  const ROUND_OFF_LIMIT = 2;
  const { user, currentLanguage, languageData } = appContext;
  const [showCc, setShowCc] = useState(false);
  const [showBcc, setShowBcc] = useState(false);
  const clientLocation = user?.site?.countryCode || false;
  const isTaxForIndividualItemsNotAllowed = false;
  //  includes(
  //   NO_ITEM_TAX_CLIENTS,
  //   clientLocation
  // );
  const isMSP = useUserMSPCheckHook();
  const isInvoiceSettingsViewAuthorised =
    props.restrictActions || useIsAuthorisedHook('invoiceSettings.view');
  const reference = user?.role?.roleFeatureList || [];
  const isEditAuthorised = useIsAuthorisedHook('quote.edit');
  const isDeleteAuthorised = useIsAuthorisedHook('quote.delete');
  const isSettingsAuthorised = useIsAuthorisedHook('client.view');
  const company = props.company || appContext.company;
  const companyInfo = appContext?.companyInfo;
  const [customModal, setCustomModal] = useState(false);
  const [invoiceSettings, setInvoiceSettings] = useState(null);
  const [quoteSettings, setQuoteSettings] = useState(null);
  const [inactiveFields, setInactiveFields] = useState([]);
  const [invoiceTemplateLoading, setInvoiceTemplateLoading] = useState(false);
  const currencyCode = companyInfo?.currency || company?.currency || 'USD';
  const countryCode = company?.countryCode || 'US';
  const { id } = match.params;
  const quoteId =
    props.quoteId || (match?.params?.viewtype === 'quoteList' ? id : null);
  const accountClient = props.accountClient || AccountClient;
  const loading = false;
  const [isStripeIntegrated, setIsStripeIntegrated] = useState(false);
  // const [currentProcessRunning, setIsCurrentProcessRunning] = useState(false);
  const ticketContext = useContext(TicketContext);
  const [columnGroup, setColumnGroup] = useState([
    { Header: 'Name', columns: [] }
  ]);
  const [activeSheetName, setActiveSheetName] = useState('Conversation');
  const [sheetActive, setSheetActive] = useState(false);
  const toggleSheetActive = useCallback((sheetName) => {
    setActiveSheetName(sheetName || null);
    setSheetActive(!sheetActive);
  });
  const [data, setData] = useState({});
  const [manipulatedData, setManipulatedData] = useState({});
  const dataRef = useRef(0);
  dataRef.current = data;
  const [records, setRecords] = useState([]);
  const [listLoading, setListLoading] = useState(true);
  const [saveActionLoading, setInvoiceGenerationInProgress] = useState(false);
  const [retry, setretry] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [loaderShow, setloaderShow] = useState(true);
  const [useAnimatedSVG, setUseAnimatedSVG] = useState(false);
  const [accessDenied, setAccessDenied] = useState(false);
  const [generateInvoiceLoaderShow, setgenerateInvoiceLoaderShow] = useState(
    false
  );
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [paymentState, setPaymentState] = useState('list');
  const [listInfo, setListInfo] = useState({});
  const listInfoByRef = React.useRef(1);
  const [active, setActive] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const editModeRef = React.useRef(2);
  editModeRef.current = editMode;
  const [actionLoading, setActionLoading] = useState(false);
  const [invoiceNote, setInvoiceNote] = useState('');
  const [integrationAppAndInvoiceId, setIntegrationAppAndInvoiceId] = useState(
    null
  );
  const [toUsers, setToUsers] = useState([]);
  const [ccUsers, setCCUsers] = useState([]);
  const [bccUsers, setBCCUsers] = useState([]);
  const [errors, setErrors] = useState(null);

  const contractsNew = useCheckFeatureGating('CONTRACT_V3')?.enabled;

  const isInvoiceAuth = useIsAuthorisedHook('invoice.view');
  const isInvoiceViewAuthorised = useMemo(() => {
    return data?.invoice?.invoiceId ? isInvoiceAuth : false;
  }, [data?.invoice?.invoiceId, isInvoiceAuth]);

  const [
    createQuote,
    { loading: createQuoteLoading }
  ] = useMutation(CREATE_QUOTE, { client: AccountClient });

  const [deleteQuote] = useMutation(DELETE_QUOTE, {
    client: AccountClient
  });

  const [showVersionModal, setShowVersionModal] = useState(false);

  const closeVersionModal = () => {
    setShowVersionModal(false);
  };
  const [showSendEmailModal, setShowSendEmailModal] = useState(false);

  // value from user preferred conversation order
  const conversationOrder = getConversationOrder() || 'ASC';

  const isAdditionalDiscountPercent =
    data?.additionalDiscountType === DISCOUNT_TYPE.PERCENT;

  const closeSendEmailModal = () => {
    setShowSendEmailModal(false);
  };

  const openSendEmailModal = () => {
    setShowSendEmailModal(true);
  };

  const [showRejectModal, setShowRejectModal] = useState(false);

  const closeRejectModal = () => {
    setShowRejectModal(false);
  };

  const openRejectModal = () => {
    setShowRejectModal(true);
  };

  const [showApprovalModal, setShowApprovalModal] = useState(false);

  const closeApprovalModal = () => {
    setShowApprovalModal(false);
  };

  const openApprovalModal = () => {
    setShowApprovalModal(true);
  };
  // const [quoteVersions, setQuoteVersions] = useState(null);

  const layoutConfig = isMSP
    ? invoiceSettings?.quoteTemplate?.layoutConfiguration
    : quoteSettings?.quoteTemplate?.layoutConfiguration;

  const LayoutConfiguration = {
    ...defaultLayoutConfigObj,
    ...layoutConfig
  };

  const tableConfig = {
    ...defaultLayoutConfigObj.tableConfig,
    ...layoutConfig?.tableConfig
  };

  const {
    pdfDownloadLoading,
    onPdfDownloadClick,
    setPdfDownloadLoading: setPDFDownloadLoading
  } = usePdfDownloader({
    downloadDetails: () => {
      const baseURL = localStorage?.getItem('apiDomain') + envConfig.fileRoot;
      const downloadDetails = new URL(`${baseURL}/download`);
      downloadDetails.search = new URLSearchParams({
        module: 'QUOTE',
        details: JSON.stringify({
          quoteId: quoteId,
          clientId: data.client.accountId
        })
      });
      return downloadDetails;
    },
    filePrefix: 'quote',
    id: quoteId
  });

  const {
    data: quoteVersions,
    loading: quoteVersionsLoading,
    error: quoteError
  } = useQuery(GET_QUOTE_VERSIONS, {
    client: AccountClient,
    skip: !isMSP,
    variables: {
      input: {
        quoteId: quoteId
      },
      isTaxSplitEnabled: true
    },
    fetchPolicy: 'network-only'
  });

  const {
    data: quoteEvents,
    loading: quoteEventsLoading,
    error: quoteEventsError,
    refetch: refetchQuoteEvents
  } = useQuery(GET_QUOTE_EVENTS, {
    client: accountClient,
    skip: props.restrictActions,
    variables: {
      input: {
        quote: { quoteId: quoteId },
        listInfo: {
          sort: [
            {
              attribute: 'createdTime',
              order: conversationOrder
            }
          ]
        }
      }
    },
    fetchPolicy: 'network-only'
  });

  const {
    loading: entitiesLoading,
    error: entitiesError,
    data: allEntities
  } = useQuery(GET_ENTITY_PROPERTIES, {
    client: accountClient
  });

  // const [
  //   getContentForSendQuote,
  //   {
  //     data: sendQuoteContent,
  //     loading: sendQuotecontentLoading,
  //     error: sendQuoteContentError
  //   }
  // ] = useLazyQuery(GET_CONTENT_FOR_SEND_QUOTE, {
  //   client: AccountClient,
  //   variables: {
  //     input: {
  //       quoteId: quoteId
  //     }
  //   },
  //   onCompleted({ getContentForSendQuote }) {
  //     if (getContentForSendQuote) {
  // setData({
  //   ...dataRef.current,
  //   conversation: {
  //     content: getContentForSendQuote.content,
  //     inlineImages: []
  //   }
  // });
  //     }
  //   },
  //   fetchPolicy: 'network-only'
  // });

  const closeModal = useCallback(() => {
    setCustomModal(false);
  });
  const openCustomModal = useCallback(() => {
    setCustomModal(true);
  });
  const [allTaxData, setAllTaxData] = useState(null);
  const [
    getAllTax,
    { loading: taxLoading, error: taxError, data: taxData }
  ] = useLazyQuery(GET_ALL_TAX, {
    client: AccountClient,
    onCompleted(response) {
      setAllTaxData(response?.getAllTax);
    }
  });
  const taxRateList = taxData
    ? formatDataForSelectDropdown(taxData?.getAllTax)
    : [];
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const {
    loading: integrationsLoading,
    data: integrationsData,
    error: integrationsError
  } = useQuery(GET_INTEGRATIONS_BY_IDS, {
    variables: { integrationIds: ['STRIPE', 'QUICK_BOOKS_ONLINE', 'XERO'] },
    client: accountClient,
    onCompleted({ getIntegrationsByIds }) {
      if (getIntegrationsByIds) {
        if (
          getIntegrationsByIds.find(
            (integration) => integration.integrationId === 'STRIPE'
          )?.activated
        ) {
          setIsStripeIntegrated(true);
        }
      }
    }
  });

  const { data: quoteConfig, loading: quoteConfigLoading } = useQuery(
    GET_QUOTE_CONFIG,
    {
      client: accountClient,
      fetchPolicy: 'network-only',
      skip: isMSP,
      onCompleted(resp) {
        setQuoteSettings((curr) => ({
          ...curr,
          quoteTemplate: {
            layoutConfiguration: {
              ...defaultLayoutConfigObj,
              ...resp?.getQuoteConfiguration?.layoutConfiguration
            },
            preferences: resp?.getQuoteConfiguration?.preferences
          }
        }));
      }
    }
  );

  const updateUsers = (section, val) => {
    switch (section) {
      case 'to':
        setToUsers(val);
        break;
      case 'cc':
        setCcUsers(val);
        break;
      case 'bcc':
        setBccUsers(val);
        break;
      default:
    }
  };

  const handleReviseQuote = (args) => {
    const name = args?.name || null;

    const inputParams = {
      client: data.client,
      site: data.site ? { id: data.site.id } : null,
      description: data.description,
      statusEnum: QUOTE_STATUS.DRAFT.value,
      quoteDate: data.quoteDate,
      expiryDate: args?.clone ? dayjs().format('YYYY-MM-DD') : data.expiryDate,
      additionalDiscount: data?.additionalDiscount || undefined,
      additionalDiscountRate: data?.additionalDiscountRate || undefined,
      addItems: data.items.map((el) => {
        return {
          [contractsNew ? 'serviceCatalogItem' : 'serviceItem']: {
            itemId: el?.serviceCatalogItem?.itemId
          },
          details: el.details,
          quantity: el.quantity || '0',
          unitPrice: el.unitPrice || '0',
          discountRate: el.discountRate,
          discountAmount: el.discountAmount,
          taxable: el.taxable,
          tax: el.tax ? { ...pick(el.tax, ['name', 'taxId']) } : undefined,
          itemOrder: el.itemOrder
        };
      }),
      revisedQuoteId: args?.clone ? undefined : data.quoteId,
      title: data.title || undefined,
      memo: data.memo || undefined,
      footer: data.template?.content || undefined,
      inlineImages: data?.template?.inlineImages?.length
        ? data?.template?.inlineImages
        : undefined,
      customFields: data?.customFields || undefined
    };

    createQuote({
      variables: {
        createQuote: preFormatForm(inputParams)
      },
      input: {
        createQuote: preFormatForm(inputParams)
      }
    }).then((res) => {
      if (res?.data?.createQuote) {
        toast('success', 'quote.creation.success');
        const quoteTabId = getTabId({
          module: 'QUOTE',
          data: { quoteId }
        });
        tabContext.closeAndOpenTab(
          { id: quoteTabId },
          {
            module: TAB_PAGES.quote,
            data: {
              quoteId: res.data.createQuote.quoteId,
              displayId: res.data.createQuote.displayId
            }
          }
        );
        useActivityTracker({
          event: 'Quote - created'
        });
        // setTimeout(() => {
        //   tabContext.closeTab({ id: quoteTabId });
        // }, 200);
        // setTimeout(() => {
        //   tabContext.openTab({
        //     module: TAB_PAGES.quote,
        //     data: {
        //       quoteId: res.data.createQuote.quoteId,
        //       displayId: res.data.createQuote.displayId
        //     }
        //   });
        // }, 500);
      }
    });
  };

  const cloneQuote = () => {
    // handleReviseQuote({ clone: true });

    const today = dayjs().format('YYYY-MM-DD');

    ticketContext.openTab({
      module: TAB_PAGES.newQuote,
      data: {
        isClone: true,
        data: {
          ...data,
          statusEnum: QUOTE_STATUS.DRAFT.value,
          quoteDate: today,
          expiryDate: data.expiryDate || null
        }
      },
      url: '/quote/create'
    });
  };

  const handleInvoiceGeneration = () => {
    setInvoiceTemplateLoading(true);
    accountClient
      .query({
        query: GET_GLOBAL_INVOICE_TEMPLATE,
        fetchPolicy: 'network-only'
      })
      .then((res) => {
        let invoiceTemplateData;
        if (res?.data?.getGlobalInvoiceTemplate) {
          invoiceTemplateData = res.data.getGlobalInvoiceTemplate;
        }

        const inputParams = {
          client: data.client,
          site: data.site ? { id: data.site.id } : null,
          statusEnum: INVOICE_STATUS.DRAFT.value,
          invoiceDate: dayjs().format('YYYY-MM-DD'),
          dueDate: dayjs().format('YYYY-MM-DD'),
          additionalDiscount: data?.additionalDiscount || undefined,
          additionalDiscountRate: data?.additionalDiscountRate || undefined,
          sentToClient: false,
          addItems: data.items.map((el) => {
            return {
              billedDate: el.billedDate || dayjs().format('YYYY-MM-DD'),
              [contractsNew ? 'serviceCatalogItem' : 'serviceItem']: {
                itemId: el?.serviceCatalogItem?.itemId
              },
              details: el.details,
              quantity: el.quantity || '0',
              unitPrice: el.unitPrice || '0',
              discountRate: el.discountRate,
              discountAmount: el.discountAmount,
              taxable: el.taxable,
              tax: el.tax ? { ...pick(el.tax, ['name', 'taxId']) } : undefined,
              offeredItem: el.offeredItem
                ? { itemId: el.offeredItem.itemId }
                : undefined,
              itemOrder: el.itemOrder
            };
          }),
          title: invoiceTemplateData?.title || data.title || undefined,
          memo: invoiceTemplateData?.memo || data.memo || undefined,
          footer:
            invoiceTemplateData?.footer || data.template?.content || undefined,
          inlineImages: data?.template?.inlineImages?.length
            ? data?.template?.inlineImages
            : undefined,
          customFields: data?.customFields || undefined
        };

        if (invoiceSettings?.invoicePaymentTerm?.paymentTermId) {
          inputParams.paymentTerm = {
            paymentTermId: invoiceSettings?.invoicePaymentTerm?.paymentTermId
          };
          inputParams.dueDate = calculateTermAndDueDate(
            inputParams.invoiceDate,
            invoiceSettings?.invoicePaymentTerm?.placeholder || null,
            invoiceSettings?.invoicePaymentTerm?.paymentTermValue || null
          );
        }

        createInvoiceFromQuote({
          variables: {
            createInvoiceFromQuoteInput: {
              quote: {
                quoteId: quoteId
              },
              invoice: preFormatForm(inputParams)
            }
          },
          input: {
            createInvoiceFromQuoteInput: {
              quote: {
                quoteId: quoteId
              },
              invoice: preFormatForm(inputParams)
            }
          }
        }).then((res) => {
          if (res?.data?.createInvoiceFromQuote) {
            toast('success', 'invoiceBuilder.invoice.creation.success');
            const quoteTabId = getTabId({
              module: 'QUOTE',
              data: { quoteId }
            });
            tabContext.closeAndOpenTab(
              { id: quoteTabId },
              {
                module: 'INVOICE',
                data: {
                  invoiceId: res.data.createInvoiceFromQuote.invoiceId,
                  displayId: res.data.createInvoiceFromQuote.displayId
                }
              }
            );
            useActivityTracker({ event: 'quote_converted_to_invoice' });
          }
        });
      })
      .catch((err) => {})
      .finally(() => {
        setInvoiceTemplateLoading(false);
      });
  };

  const [
    getClientInvoiceSettings,
    {
      loading: clientInvoiceSettingsLoading,
      data: clientInvoiceSettings,
      error: clientInvoiceSettingsError
    }
  ] = customUseLazyQuery(FETCH_INVOICE_CONFIGURATION, {
    client: accountClient,
    fetchPolicy: 'cache-and-network',
    onCompleted(response) {
      setInvoiceSettings({
        ...response?.fetchInvoiceConfiguration,
        quoteTemplate: {
          ...response?.fetchInvoiceConfiguration?.quoteTemplate,
          layoutConfiguration: {
            ...defaultLayoutConfigObj,
            ...response?.fetchInvoiceConfiguration?.quoteTemplate
              ?.layoutConfiguration
          }
        }
      });
    }
  });
  // Invoice send and push to integrated app actions
  const [pushToThirdParty] = useMutation(PUSH_INVOICE, {
    client: AccountClient
  });

  const [sendInvoice] = useMutation(SEND_INVOICES, {
    client: AccountClient
  });

  const [updateSendIntegrationStatus] = useLazyQuery(
    GET_SEND_AND_INTEGRATION_STATUS,
    {
      client: AccountClient,
      onCompleted: ({ getQuote }) => {
        if (getQuote) {
          setData({ ...data, ...getQuote });
        }
      },
      fetchPolicy: 'network-only'
    }
  );

  const thirdPartyInvoiceApp =
    integrationsData?.getIntegrationsByIds?.length > 0 &&
    integrationsData?.getIntegrationsByIds?.find(
      (el) =>
        (el.integrationId === 'QUICK_BOOKS_ONLINE' ||
          el.integrationId === 'XERO') &&
        el.activated
    );

  const isXeroIntegrated = !!integrationsData?.getIntegrationsByIds?.find(
    (el) => el.integrationId === 'XERO'
  );

  const updateTemplate = (obj) => {
    const modifiedData = cloneDeep(dataRef.current);
    modifiedData.template = {
      ...modifiedData.template,
      ...obj
    };
    setData(modifiedData);
  };

  const updateMemo = (val) => {
    const modifiedData = cloneDeep(dataRef.current);
    modifiedData.memo = val;
    setData(modifiedData);
  };
  const updateTitle = (val) => {
    const modifiedData = cloneDeep(dataRef.current);
    modifiedData.title = val;
    setData(modifiedData);
  };

  const updateDescription = (val) => {
    const modifiedData = cloneDeep(dataRef.current);
    modifiedData.description = val;
    setData(modifiedData);
  };
  const thirdPartyAppId = thirdPartyInvoiceApp?.integrationId;

  const allowPushToThirdParty = !!thirdPartyInvoiceApp?.activated;

  const notClient = appContext.accountType !== 'CLIENT';

  const [updateInvoice] = useMutation(UPDATE_INVOICE, {
    client: AccountClient
  });

  const [updateQuote, { loading: quoteUpdateLoading }] = useMutation(
    UPDATE_QUOTE,
    {
      client: AccountClient,
      onCompleted(response) {
        const res = {};
        res.data = response;
        if (res?.data?.updateQuote) {
          toast('success', 'quote.regeneration.success');
          setData({
            ...res?.data?.updateQuote,
            template: {
              content: res?.data?.updateQuote?.footer || '',
              inlineImages: []
            },
            client: data.client
          });
          setManipulatedData({
            ...res?.data?.updateQuote,
            template: {
              content: res?.data?.updateQuote?.footer || '',
              inlineImages: []
            },
            client: data.client
          });
        }
      }
    }
  );

  const [
    createInvoiceFromQuote,
    { loading: createInvoiceLoading }
  ] = useMutation(CREATE_INVOICE_FROM_QUOTE, { client: AccountClient });

  const [approveQuote, { loading: approvalLoading }] = useMutation(
    APPROVE_OR_REJECT_QUOTE,
    {
      client: accountClient
    }
  );

  const [deleteInvoice] = useMutation(DELETE_INVOICE, {
    client: AccountClient
  });

  useEffect(() => {
    if (quoteId) fetchViewData();
    setEditMode(false);
    setPDFDownloadLoading(false);
  }, [quoteId]);

  // const calculateData = (modifiedData) => {
  //   // setIsCurrentProcessRunning(true);
  //   currentProcessRunning = true;
  //   if (modifiedData.isQueue) {
  //     // console.log('calling from queue');
  //   }

  //   invoiceWorker.postMessage({ msg: 'calculateData', data: modifiedData });
  // };

  // useEffect(() => {
  //   invoiceWorker.onmessage = (event) => {
  //     setData(event.data);
  //     // setIsCurrentProcessRunning(false);
  //     currentProcessRunning = false;
  //     if (dataQueue.length) {
  //       const dataToCalculate = dataQueue.shift();
  //       const {
  //         key,
  //         value,
  //         field,
  //         meta,
  //         properties,
  //         itemProperties
  //       } = dataToCalculate;
  //       const modifiedData = cloneDeep(event.data);
  //       calculateData({
  //         modifiedData,
  //         key,
  //         value,
  //         field,
  //         meta,
  //         properties,
  //         itemProperties,
  //         isQueue: true
  //       });
  //     }
  //   };
  // }, [invoiceWorker]);

  const handleUpdateQuote = (updateParams) => {
    const parsedObject = getParsedCrudData(
      manipulatedData.items,
      data.items,
      'itemId'
    );

    let dragReorderedArray = [];
    let isDataModified;

    if (parsedObject.updatedItems.length) {
      const { result, dataModified } = findItemOrderDiff(
        manipulatedData.items,
        parsedObject.updatedItems
      );
      dragReorderedArray = result;
      isDataModified = dataModified;
    }

    let inputObject = {};
    const updatedLineItems = !isDataModified
      ? dragReorderedArray
      : parsedObject.updatedItems.map((el) => {
          return {
            itemId: el.itemId,
            itemOrder: el.itemOrder,
            details: el.details,
            [contractsNew ? 'serviceCatalogItem' : 'serviceItem']: {
              itemId: el?.serviceCatalogItem?.itemId
            },
            quantity: el.quantity,
            unitPrice: el.unitPrice,
            discountRate:
              el.discountRate === null
                ? el.discountRate
                : el.hasOwnProperty('discountRate')
                ? el.discountRate || '0'
                : null,
            discountAmount:
              el.discountAmount === null
                ? el.discountAmount
                : el.hasOwnProperty('discountAmount')
                ? el.discountAmount || '0'
                : null,
            taxable: el.taxable,
            tax: el?.tax?.taxId
              ? {
                  taxId: el?.tax?.taxId
                }
              : null
          };
        });

    const deletedLineItems = parsedObject.deletedItems.map((el) => {
      return {
        itemId: el.itemId
      };
    });
    const addedLineItems = parsedObject.addedItems.map((el) => {
      return {
        itemOrder: el.itemOrder,
        details: el.details,
        offeredItem: el.offeredItem
          ? {
              itemId: el.offeredItem.itemId
            }
          : undefined,
        [contractsNew ? 'serviceCatalogItem' : 'serviceItem']: {
          itemId: el?.serviceCatalogItem?.itemId
        },
        quantity: el.quantity || '0',
        unitPrice: el.unitPrice || '0',
        discountRate:
          el.discountRate === null
            ? el.discountRate
            : el.hasOwnProperty('discountRate')
            ? el.discountRate || '0'
            : null,
        discountAmount:
          el.discountAmount === null
            ? el.discountAmount
            : el.hasOwnProperty('discountAmount')
            ? el.discountAmount || '0'
            : null,
        taxable: el.taxable,
        tax: el?.tax?.taxId
          ? {
              taxId: el?.tax?.taxId
            }
          : null
      };
    });
    if (
      manipulatedData.additionalDiscountRate !== data.additionalDiscountRate
    ) {
      inputObject.additionalDiscountRate =
        data.additionalDiscountRate === null
          ? data.additionalDiscountRate
          : data.additionalDiscountRate || '0';
    }
    if (manipulatedData.additionalDiscount !== data.additionalDiscount) {
      inputObject.additionalDiscount =
        data.additionalDiscount === null
          ? data.additionalDiscount
          : data.additionalDiscount || '0';
    }
    if (parsedObject.updatedItems.length) {
      inputObject.updateItems = updatedLineItems;
    }
    if (parsedObject.deletedItems.length) {
      inputObject.deleteItems = deletedLineItems;
    }
    if (parsedObject.addedItems.length) {
      inputObject.addItems = addedLineItems;
    }
    if (manipulatedData.quoteDate !== data.quoteDate) {
      inputObject.quoteDate = data.quoteDate;
    }
    if (manipulatedData.expiryDate !== data.expiryDate) {
      inputObject.expiryDate = data.expiryDate;
    }
    inputObject.title = data.title || undefined;
    if (manipulatedData.title !== data.title) {
      inputObject.title = data.title;
    }

    inputObject.memo =
      manipulatedData.memo !== data.memo ? data.memo : undefined;
    inputObject.footer = data.template?.content || undefined;
    inputObject.inlineImages = data?.template?.inlineImages?.length
      ? data?.template?.inlineImages
      : undefined;
    inputObject.description = data.description;
    inputObject.customFields = data?.customFields || undefined;
    if (updateParams) {
      const additionalParams = { ...updateParams };
      inputObject = { ...inputObject, ...additionalParams };
    }

    // Validation
    const validationResult = validateForm(
      preFormatForm({ ...data }),
      quoteConstraints
    );

    if (validationResult) {
      setErrors({ ...validationResult });
      return;
    }
    setErrors(null);

    setInvoiceGenerationInProgress(true);
    updateQuote({
      variables: {
        updateQuote: {
          quoteId,
          ...inputObject
        },
        isTaxSplitEnabled: true
      }
    })
      .then((res) => {
        setInvoiceGenerationInProgress(false);
        closeSendEmailModal();
        refetchQuoteEvents();
        if (res?.data?.updateQuote?.statusEnum !== QUOTE_STATUS.DRAFT.value) {
          setEditMode(false);
        }
      })
      .catch((err) => {
        setInvoiceGenerationInProgress(false);
      });
  };

  const updateProperties = (args) => {
    updatePropertiesHelper(args, dataRef, setData, invoiceSettings);
  };

  const calculateDataWithoutWorker = (arg) => {
    setData(calculateData(arg));
  };

  const { mspInfo: mspConf, clientInfo: clientConf } = LayoutConfiguration;

  const showClientConf = Object.keys(clientConf).some((key) => clientConf[key]);

  const modifyData = (args) => {
    const {
      key,
      value,
      field,
      meta,
      properties,
      itemProperties,
      miscProperty,
      miscItem
    } = args;
    // if (currentProcessRunning) {
    //   console.log('process running', args);
    //   dataQueue.push(args);
    //   return;
    // }
    let modifiedData = cloneDeep(dataRef.current);
    // console.log('modifying data');
    // calculateData({
    //   modifiedData,
    //   key,
    //   value,
    //   field,
    //   meta,
    //   properties,
    //   itemProperties,
    //   miscProperty,
    //   miscItem
    // });
    calculateDataWithoutWorker({
      modifiedData,
      key,
      value,
      field,
      meta,
      properties,
      itemProperties,
      miscProperty,
      miscItem
    });
  };

  const setColumnData = () => {
    setColumnGroup(
      configureTableColumns({
        intl,
        tableConfig,
        data,
        onChange: modifyData,
        currencyCode,
        countryCode,
        editModeRef,
        isQuote: true
      })
    );
  };

  useEffect(() => {
    setColumnData();
  }, [editMode]);

  useEffect(() => {
    setColumnData();
  }, [tableConfig.tax, tableConfig.discountRate, data]);

  const checkRowHighlight = (row) =>
    checkRowHighlightHelper(row, manipulatedData);

  /**
   * Method to get Service items.
   * Call this method to fetch/refetch the data on mounting/sorting/filtering
   * @param {object} personalization
   * @param {object} pageOptions
   */

  const fetchViewData = (personalization, pageOptions) => {
    setListLoading(true);
    setloaderShow(true);
    setretry(false);
    setgenerateInvoiceLoaderShow(false);
    setAccessDenied(false);
    let apiTimeout = setTimeout(getQuoteAPI, 3000);
    let time = 10;
    let clientCustomFields = [];

    async function getQuoteAPI() {
      try {
        await accountClient
          .query({
            query: GET_QUOTE_CONFIG
          })
          .then((res) => {
            if (res?.data?.getQuoteConfiguration?.preferences?.fieldSettings) {
              clientCustomFields = res?.data?.getQuoteConfiguration?.preferences?.fieldSettings?.filter(
                (field) => field?.entity === 'Client'
              );
              const customFieldsToGetDetails = res?.data?.getQuoteConfiguration?.preferences?.fieldSettings
                ?.filter((field) => field?.fieldCategory === 'CUSTOM')
                ?.filter((field) => {
                  if (field?.entity === 'Quote') {
                    return isQuoteCustomFieldsAuthorised;
                  }
                  if (field?.entity === 'Client') {
                    return isClientCustomFieldsAuthorised;
                  }
                  return false;
                });
              if (customFieldsToGetDetails?.length) {
                accountClient
                  .query({
                    query: GET_FIELDS,
                    variables: {
                      input: customFieldsToGetDetails?.map((field) => ({
                        entity:
                          field?.entity === 'Quote' ? 'Billing' : field?.entity,
                        columnName: field?.fieldName
                      }))
                    },
                    fetchPolicy: 'no-cache'
                  })
                  .then((res) => {
                    setInactiveFields(
                      res?.data?.getFields
                        ?.filter((field) => field?.status === 'INACTIVE')
                        ?.map((field) => field?.columnName)
                    );
                  });
              }
            }
          });

        const response = await accountClient.query({
          query: GET_QUOTE,
          variables: {
            input: { quoteId: quoteId },
            isTaxSplitEnabled: true,
            clientCustomFields:
              clientCustomFields?.map((field) => field?.fieldName) || []
          },
          fetchPolicy: 'network-only'
        });
        // getContentForSendQuote();
        if (clientCustomFields) {
          clientCustomFieldsRef.current =
            response?.data?.getQuote?.client?.customFields;
        }
        if (response?.data?.getQuote?.operationStatus === 'PROGRESS') {
          setgenerateInvoiceLoaderShow(true);
          setloaderShow(false);
          if (time < 100) {
            apiTimeout = setTimeout(getQuoteAPI, 3000);
            time += 10;
          } else {
            setloaderShow(false);
            setretry(true);
            clearTimeout(apiTimeout);
          }
        } else {
          setloaderShow(false);
          setgenerateInvoiceLoaderShow(false);
          clearTimeout(apiTimeout);

          setColumnGroup(
            configureTableColumns({
              intl,
              tableConfig,
              data: response?.data?.getQuote,
              onChange: modifyData,
              currencyCode,
              countryCode,
              editModeRef,
              editMode,
              isQuote: true
            })
          );
          if (
            response?.data?.getQuote?.client?.accountId &&
            quoteId &&
            isInvoiceSettingsViewAuthorised
          ) {
            getClientInvoiceSettings({
              variables: {
                input: {
                  accountId: response?.data?.getQuote?.client?.accountId
                }
              }
            });
          }
          if (response?.data?.getQuote) {
            setData({
              ...response?.data?.getQuote,
              template: {
                content: response?.data?.getQuote?.footer || '',
                inlineImages: []
              }
            });
          }
          setIntegrationAppAndInvoiceId(
            response?.data?.getQuote?.integratedAppInvoiceId?.split('#')
          );
          setManipulatedData(response?.data?.getQuote);
          setInvoiceNote(response?.data?.getQuote?.notes || '');
          setListLoading(false);
          if (response?.data?.getQuote?.statusEnum === 'DRAFT') {
            setEditMode(true);
          }
          if (isSendQuote && response?.data?.getQuote?.statusEnum === 'DRAFT') {
            openSendEmailModal();
          }
          // Failure case. If required, alert the user.
        }
      } catch (err) {
        setloaderShow(false);
        setgenerateInvoiceLoaderShow(false);
        clearTimeout(apiTimeout);

        if (err.graphQLErrors) {
          if (
            err.graphQLErrors.find(({ extensions }) => {
              const accesDeniedError = !!extensions?.clientError?.find(
                ({ errorCode }) => errorCode === 403
              );
              return accesDeniedError;
            })
          ) {
            setListLoading(false);
            setAccessDenied(true);
          }
        }
      }
    }
  };

  useEffect(() => {
    if (quoteId) {
      fetchViewData();
      // getQuoteVersions();
    }
    // return function cleanup() {
    // if (invoiceWorker) {
    // invoiceWorker.terminate();
    // }
    // };
  }, []);

  if (accessDenied) {
    return (
      <div className="flex actr jctr fhp w100 tcenter">
        <NoDataCard
          imageURL={`url(${envConfig.imageRoot}svg/deleted_error_page.svg)`}
          text={getTranslatedText(intl, 'quote.deleted.title')}
          description={getTranslatedText(intl, 'quote.deleted.description')}
        />
      </div>
    );
  }

  if (listLoading || clientInvoiceSettingsLoading) {
    if (loaderShow)
      return (
        <div className="fhp w100">
          <InvoiceQuoteLoader />
        </div>
      );

    return (
      <div className="d-inline-grid center jctr fw pt-200">
        {generateInvoiceLoaderShow && !retry && (
          <div className="pt16 sops-display-block">
            <HourGlassLoader
              heading={getTranslatedText(intl, 'invoice.create.loading')}
              imageURL={`${envConfig.imageRoot}svg/Hourglass.svg`}
              boxWidth="660px"
            />
          </div>
        )}

        {retry ? (
          <div className="pt16 margin-auto text-align-centr">
            <span className="pt16 mb16 sops-display-block">
              <FormattedMessage id="invoice.allInvoice.retry.description" />
            </span>

            <Button primary onClick={fetchViewData}>
              <FormattedMessage id="invoice.allInvoice.retry.again" />
            </Button>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
  if (isEmpty(data)) {
    return <div>loading...</div>;
  }
  const { client, site } = data;
  const module = ALL_MODULES.invoice;
  const details = {
    quoteId: quoteId
  };
  const url = getDownloadURL({ module, details, endPoint: 'direct_download' });

  const { rows, grandTotal } = generateInvoiceOrQuoteSummaryRows({
    data,
    editMode,
    intl,
    isXeroIntegrated,
    integrationsLoading,
    integrationsError,
    isDetailsPage: true,
    isAdditionalDiscountPercent
  });

  const getPrefix = (el) => {
    switch (el.type) {
      case 'Tag':
        return (
          <div className="flex jend mr10">
            <Tag>{el.prefix}</Tag>
          </div>
        );
      default:
        return <>{el.prefix}</>;
    }
  };
  const getLabel = (el) => {
    switch (el.name) {
      case 'addAdditionalDiscount':
        return (
          <Button
            plain
            onClick={() => {
              modifyData({
                properties: {
                  additionalDiscountRate: '0',
                  additionalDiscountType: DISCOUNT_TYPE.PERCENT
                }
              });
            }}
          >
            <div>{el.label}</div>
          </Button>
        );
      case 'taxEdit':
        return (
          <Dropdown
            className="rule-fields"
            value={
              taxRateList.find(
                (t) => t.taxId === data.taxes?.[0]?.tax?.taxId
              ) || {
                ...data.taxes?.[0]?.tax,
                value: data.taxes?.[0]?.tax?.name,
                label: data.taxes?.[0]?.tax?.name
              }
            }
            onMenuOpen={() => {
              getAllTax();
            }}
            onChange={(val) => {
              modifyData({
                miscProperty: 'clientTax',
                value: { ...omit(val, ['label', 'value']) }
              });
            }}
            classNamePrefix="value_selector"
            formatGroupLabel={formatGroupLabel}
            components={{ IndicatorSeparator, DropdownIndicator }}
            options={taxRateList}
            menuPortalTarget={document.body}
            menuPlacement="auto"
            closeMenuOnScroll={(e) => {
              return (
                e.target &&
                e.target.classList &&
                !(e.target.classList.value.indexOf('menu-list') > -1)
              );
            }}
            name="valueselector"
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              menu: (base) => ({ ...base, zIndex: 9999 })
            }}
            noOptionsMessage={() => {
              return taxLoading ? 'Loading...' : 'No options';
            }}
          />
        );
      default:
        return <>{el.label}</>;
    }
  };

  const getValue = (el) => {
    switch (el.name) {
      case 'addAdditionalDiscount':
        return '';
      default:
        return <CurrencyText value={el.value} />;
    }
  };

  const getRate = (el) => {
    const Comp = !isAdditionalDiscountPercent ? CurrencyField : TextField;
    switch (el.name) {
      case 'additionalDiscountEdit':
        return (
          <div className="ml-10">
            <Comp
              autoComplete="off"
              type="number"
              suffix={
                <div
                  className="flex center pointer br-5 h-30"
                  clicked={clicked}
                  onClick={() => {
                    setClicked(true);
                    modifyData({
                      properties: isAdditionalDiscountPercent
                        ? {
                            additionalDiscount:
                              data.additionalDiscountRate || '0',
                            additionalDiscountRate: null,
                            additionalDiscountType: DISCOUNT_TYPE.AMOUNT
                          }
                        : {
                            additionalDiscount: null,
                            additionalDiscountRate: String(
                              clamp(
                                Number(data.additionalDiscount || '0'),
                                0,
                                100
                              )
                            ),
                            additionalDiscountType: DISCOUNT_TYPE.PERCENT
                          }
                    });
                    setTimeout(() => {
                      setClicked(false);
                    }, 200);
                  }}
                >
                  <div className="flex center">
                    <div>
                      {!isAdditionalDiscountPercent ? 'amount' : 'percent'}
                    </div>
                    <div className="ml4">
                      <SVGIcon name="ArrowDown" />
                    </div>
                  </div>
                </div>
              }
              onChange={(changedVal) => {
                const sTotal = getSubTotal(data?.items);
                const tRates = getTaxes(data);
                const currentTotal = sTotal + tRates;
                let val = changedVal;
                if (
                  !isAdditionalDiscountPercent &&
                  Number(changedVal) > currentTotal
                ) {
                  val = String(currentTotal);
                }
                if (Number(val) < 0) val = '0';
                modifyData({
                  properties: isAdditionalDiscountPercent
                    ? {
                        additionalDiscountRate:
                          Number(val) > 100 ? '100' : val || '',
                        additionalDiscount: null,
                        additionalDiscountType: DISCOUNT_TYPE.PERCENT
                      }
                    : {
                        additionalDiscountRate: null,
                        additionalDiscount: val || '',
                        additionalDiscountType: DISCOUNT_TYPE.AMOUNT
                      }
                });
              }}
              value={
                isAdditionalDiscountPercent
                  ? data.additionalDiscountRate
                  : data.additionalDiscount
              }
            />
          </div>
        );
      case 'additionalDiscount':
        if (isAdditionalDiscountPercent) {
          return `${data.additionalDiscountRate}%`;
        }
        return '';
      default:
        return el.rate ? `${el.rate}%` : '';
    }
  };

  const renderSiteInfo = (info) => {
    if (info) {
      return <div className="site-info">{info}</div>;
    }
    return null;
  };

  const handleInvoiceUpdate = (status) => {
    setActionLoading(true);
    updateInvoice({
      variables: {
        updatedInvoice: {
          quoteId,
          statusEnum: status
        }
      },
      input: {
        updatedInvoice: {
          quoteId,
          statusEnum: status
        }
      }
    })
      .then((res) => {
        setActionLoading(false);
        if (res?.data?.updateInvoice) {
          // setUseAnimatedSVG(true);
          toast('success', 'invoice.status.update.success');
          toggleActive();
          setData({
            ...res?.data?.updateInvoice,
            client: data.client
          });
          setManipulatedData({
            ...res?.data?.updateInvoice,
            client: data.client
          });
        }
      })
      .catch((err) => {
        setActionLoading(false);
      });
  };

  const saveNotes = (value) => {
    if (value.trim() === data.notes) return;
    setActive(false);
    updateInvoice({
      variables: {
        updatedInvoice: {
          quoteId,
          notes: value.trim() || null
        }
      },
      input: {
        updatedInvoice: {
          quoteId,
          notes: value.trim() || null
        }
      }
    })
      .then((res) => {
        if (res?.data?.updateInvoice) {
          setData({ ...data, notes: res.data.updateInvoice.notes });
        } else {
          setInvoiceNote(data?.notes);
        }
      })
      .catch(() => {});
  };

  const handleInvoiceDelete = () => {
    deleteInvoice({
      variables: {
        quoteId
      },
      input: {
        quoteId
      }
    })
      .then((res) => {
        toggleActive();
        if (res?.data?.deleteInvoice) {
          const invoiceTabId = getTabId({
            module: 'INVOICE',
            data: {
              quoteId: res.data.deleteInvoice
            }
          });
          ticketContext.closeTab({ id: invoiceTabId });
          toast('success', 'invoice.delete.success');
        }
      })
      .catch(() => {
        toggleActive();
      });
  };

  const getPrintWidth = (col) => {
    switch (col.name) {
      case 'worklogDate':
        return 110;
      case 'itemDetails':
        return 110;
      case 'details':
        return 150;
      case 'quantity':
        return 100;
      case 'unitPrice':
        return 100;
      case 'discount':
        return 100;
      default:
        return 100;
    }
  };

  const getPrintCellType = (col) => {
    switch (col.field.name) {
      case 'itemDetails':
        return 'ServiceItem';
      case 'details':
        return 'Multiline';
      case 'quantity':
        return 'Text';
      case 'unitPrice':
        return 'Currency';
      case 'discountRate':
      case 'discount':
        return 'Percent';
      case 'tax':
        return 'Tax';
      case 'amount':
        return 'Amount';
      default:
        return 'Text';
    }
  };

  const getPrintPrefix = (el) => {
    switch (el.type) {
      case 'Tag':
        return (
          <div className="flex jend mr10">
            <div className="status-tag flex center">{el.prefix}</div>
          </div>
        );
      default:
        return <>{el.prefix}</>;
    }
  };
  const getPrintLabel = (el) => {
    switch (el.name) {
      default:
        return <>{el.label}</>;
    }
  };

  const getPrintValue = (el) => {
    switch (el.name) {
      case 'addAdditionalDiscount':
        return '';
      default:
        return <CurrencyText value={el.value} />;
    }
  };

  const getPrintRate = (el) => {
    let displayVal = 'percent';
    switch (el.name) {
      case 'additionalDiscount':
        if (data.additionalDiscountRate) {
          return `${data.additionalDiscountRate}%`;
        }
        return '';
      default:
        return el.rate ? `${el.rate}%` : '';
    }
  };

  const getPrintData = () => {
    return (
      <IntlProvider
        onError={(err) => {
          console.error(err);
        }}
        locale={currentLanguage.value?.replace(/_/g, '-')}
        messages={languageData}
        // messages={TranslationMessages[selectedLangCode]}
      >
        <div
          id="invoice-pdf"
          fullHeight
          contentPadding="20px 0"
          className={`full-height bg-white super-pdf-holder`}
          clicked={clicked}
          ref={(node) => {
            if (!invoiceNode.current) {
              invoiceNode.current = node;
            }
          }}
        >
          <style>{pdfStyles}</style>
          <div className={`full-height `}>
            <div>
              <div className="pdf-header center content-padding flex">
                <div element="h1" weight="bold" className="invoice-title">
                  {data.title || `Estimate #${data.displayId}`}
                </div>
                <div className="ml-10">
                  <div
                    className="status-tag flex center uppercase f-12"
                    style={{
                      background:
                        QUOTE_STATUS[data.statusEnum].color || 'transparent',
                      color: QUOTE_STATUS[data.statusEnum].fontColor || '#000'
                    }}
                  >
                    {getTranslatedText(
                      intl,
                      QUOTE_STATUS[data.statusEnum].label
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="client-info grid g40 content-padding">
              <div className="flex">
                <div>
                  <BrandingLogo
                    alignVertical
                    hideName={!mspConf?.companyname}
                  />
                  {mspConf?.addressLine1 && renderSiteInfo(company?.line1)}
                  {mspConf?.addressLine2 && renderSiteInfo(company?.line2)}
                  {mspConf?.addressLine3 && renderSiteInfo(company?.line3)}
                  {mspConf?.city && renderSiteInfo(company?.city)}
                  {mspConf?.state &&
                    company?.countryCode &&
                    company?.stateCode && (
                      <div className="site-info">
                        <StateCountryLabel
                          countryCode={company?.countryCode}
                          stateCode={company?.stateCode}
                        />
                      </div>
                    )}
                  {mspConf?.country && (
                    <div className="site-info">
                      <StateCountryLabel countryCode={company?.countryCode} />
                    </div>
                  )}
                  {mspConf?.postalCode && renderSiteInfo(company?.postalCode)}
                </div>
                <div className="mlauto flex center self-start">
                  {includes(
                    [QUOTE_STATUS.REJECTED.value, QUOTE_STATUS.APPROVED.value],
                    data.statusEnum
                  ) && (
                    <div>
                      <BackgroundIcon
                        className="mr-10"
                        url={`url(${
                          envConfig.imageRoot
                        }svg/${data.statusEnum.toLowerCase()}.svg)`}
                        height="100px"
                        width="100px"
                      />
                    </div>
                  )}
                  <div className="flex col aend">
                    <div className="info flex center">
                      <span>
                        {getTranslatedText(intl, 'quote.details.heading')}
                      </span>
                      <span className="ml8">
                        <B1>{`#${data.displayId}`}</B1>
                      </span>
                    </div>
                    <div className="info flex center">
                      <FormattedMessage id="quote.details.quoteDate" /> :{' '}
                      <div className="b2 ml8">
                        <DateTimeFormatter
                          type="date"
                          // date={dayjs().format('YYYY-MM-DD')}
                          date={data.quoteDate}
                        />
                        {/* {`${data.invoiceDate}`} */}
                      </div>
                    </div>
                    <div className="info flex center">
                      <FormattedMessage id="quote.details.expiryDate" /> :{' '}
                      <div className="b2 ml8">
                        {data.expiryDate ? (
                          <DateTimeFormatter
                            type="date"
                            // date={dayjs().format('YYYY-MM-DD')}
                            date={data.expiryDate}
                          />
                        ) : (
                          'NA'
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                {showClientConf && (
                  <div className="b3t2 uppercase sub-header f-12">
                    <FormattedMessage id="invoice.details.billTo" />
                  </div>
                )}
                <h1>
                  {clientConf?.clientName && client?.name ? client.name : ''}
                  {clientConf?.clientName && clientConf?.siteName ? ` - ` : ''}
                  {clientConf?.siteName && site?.name ? site?.name : ''}
                </h1>
                {clientConf?.addressLine1 && renderSiteInfo(site?.line1)}
                {clientConf?.addressLine2 && renderSiteInfo(site?.line2)}
                {clientConf?.addressLine3 && renderSiteInfo(site?.line3)}
                {clientConf?.city && renderSiteInfo(site?.city)}
                {clientConf?.state && site?.countryCode && site?.stateCode && (
                  <div className="site-info">
                    <StateCountryLabel
                      countryCode={site?.countryCode}
                      stateCode={site?.stateCode}
                    />
                  </div>
                )}
                {clientConf?.country && (
                  <div className="site-info">
                    <StateCountryLabel countryCode={site?.countryCode} />
                  </div>
                )}
                {clientConf?.postalCode && renderSiteInfo(site?.postalCode)}
              </div>
            </div>
            <div className="mt40 content-padding">
              <div className="super-table-container">
                <TableForPrint
                  context={{ records: [] }}
                  columns={columnGroup[0].columns.map((el) => {
                    return {
                      ...el,
                      width: getPrintWidth(el),
                      type: getPrintCellType(el),
                      company: company
                    };
                  })}
                  data={data?.items || []}
                  setData={setData}
                  rowCount={10000}
                  refreshTable={fetchViewData}
                  listInfo={listInfo}
                  pagination={false}
                  pages={0}
                  defaultColumnCells={defaultColumnCells}
                  recordCount={listInfo.totalCount}
                  activePage={listInfo.page || 0}
                  isLoading={listLoading || data.operationStatus === 'PROGRESS'}
                  noBulkSelect
                  fullHeight
                  dark
                  emptyState={{
                    nodataImage: `${envConfig.imageRoot}svg/not-found.svg`,
                    heading: getTranslatedText(intl, 'invoice.list.noItems'),
                    description: ''
                  }}
                  alignStart
                  checkRowHighlight={checkRowHighlight}
                />
              </div>
            </div>
            <div className="total-section mt-30 p20 pb-100 avoid-break flex g20">
              {data?.memo && (
                <div className="flex fg1">
                  <div>{data?.memo}</div>
                </div>
              )}
              <div className="mt10 mlauto mr8">
                <div className="cost mt10 mlauto mr8 w700 f-16">
                  {rows.length > 0
                    ? rows.map((el) => {
                        return (
                          <div className="flex row center mlauto">
                            <div className="cell">{getPrintPrefix(el)}</div>
                            <div className="cell">{getPrintLabel(el)}</div>
                            <div className="cell">{getPrintRate(el)}</div>
                            <div className="flex cell jend pr-20 bold">
                              {getPrintValue(el)}
                            </div>
                          </div>
                        );
                      })
                    : ''}
                </div>
                <div className="flex mr8 p20 mt-30 bold quote-total">
                  <div className="flex jend fb50 bold">
                    <FormattedMessage id="invoice.details.total" />
                  </div>
                  <div className="ml8 mlauto flex jend fb50 bold">
                    <CurrencyText value={grandTotal} />
                  </div>
                </div>
              </div>
            </div>
            {data.statusEnum === QUOTE_STATUS.APPROVED.value ? (
              <div className="flex col aend mt-20 pr40">
                <FormattedMessage id="quote.details.approvedBy" />
                <div>{data?.approverName}</div>
              </div>
            ) : (
              ''
            )}
            {data?.footer ? (
              <div className="ml20 mr-20 footer avoid-break">
                <div
                  dangerouslySetInnerHTML={{
                    __html: dompurifier(data?.footer)
                  }}
                ></div>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </IntlProvider>
    );
  };

  const pdfDownloadClick = () => onPdfDownloadClick();

  const CREATE_INVOICE_OPTIONS = [
    {
      name: QUOTE_STATUS.DRAFT.value,
      icon: 'Save',
      label: 'invoiceBuilder.actions.create.saveAsDraft'
    }
  ];
  const splitOptions = CREATE_INVOICE_OPTIONS.map((option) => {
    return {
      name: option.name,
      content: (
        <div className="flex center">
          <div className="mr8 flex center">
            <SVGIcon name={option.icon} />
          </div>
          <FormattedMessage id={option.label} />
        </div>
      )
    };
  });

  const handleConfirmatonBeforeUpdate = () => {};

  const modalActivator = (
    <Button
      className="pointer flex center"
      icon={<SVGIcon name="Delete" />}
      loading={deleteLoading}
    >
      <FormattedMessage id="common.delete" />
    </Button>
  );

  const handleRejectionSubmit = (params) => {
    // console.log(params);
    approveQuote({
      variables: {
        approveQuote: {
          quote: {
            quoteId: quoteId
          },
          approver: {
            approverId: params?.user?.userId,
            approverName: params?.user?.name
          },
          status: 'REJECTED',
          comment: params.comments
        }
      }
    })
      .then((res) => {
        if (res?.data?.approveQuote) {
          closeRejectModal();
          setData({
            ...dataRef.current,
            statusEnum: QUOTE_STATUS.REJECTED.value
          });

          if (isMSP && !props.restrictActions) {
            handleReviseQuote();
            useActivityTracker({ event: 'quote_rejected_by_tech' });
          } else {
            useActivityTracker({ event: 'quote_rejected_by_requester' });
          }
          refetchQuoteEvents();
        }
      })
      .catch((err) => {
        // closeRejectModal();
        // setData({
        //   ...dataRef.current,
        //   statusEnum: QUOTE_STATUS.REJECTED.value
        // });
      });
  };

  const handleApprovalSubmit = (params) => {
    // console.log(params);
    approveQuote({
      variables: {
        approveQuote: {
          quote: {
            quoteId: quoteId
          },
          approver: {
            approverId: params?.user?.userId,
            approverName: params?.user?.name
          },
          status: 'APPROVED',
          comment: params.comments
        }
      }
    })
      .then((res) => {
        if (res?.data?.approveQuote) {
          closeApprovalModal();
          setData({
            ...dataRef.current,
            statusEnum: QUOTE_STATUS.APPROVED.value,
            approverName: params?.user?.name
          });

          if (isMSP && !props.restrictActions) {
            handleInvoiceGeneration();
            useActivityTracker({ event: 'quote_approved_by_tech' });
          } else {
            useActivityTracker({
              event: 'quote_approved_by_requester'
            });
          }
          refetchQuoteEvents();
        }
      })
      .catch((err) => {
        // closeRejectModal();
        // setData({
        //   ...dataRef.current,
        //   statusEnum: QUOTE_STATUS.REJECTED.value
        // });
      });
  };

  const handleRejectionBeforeRevision = () => {
    openRejectModal();
  };

  const handleApprovalBeforeGeneration = () => {
    openApprovalModal();
  };

  const handleDeleteQuote = (quoteId) => {
    setDeleteLoading(true);
    deleteQuote({
      variables: {
        input: [{ quoteId }]
      }
    })
      .then((res) => {
        if (res?.data?.deleteQuotes) {
          const quoteTabId = getTabId({
            module: 'QUOTE',
            data: { quoteId }
          });
          ticketContext.closeTab({ id: quoteTabId });
          toast('success', 'quote.delete.success');
        }
      })
      .finally(() => {
        setDeleteLoading(false);
      });
  };

  const QuoteDeleteButton = (
    <AccessControl
      roleToCheck="quote.delete" // TODO-QUOTE: Change to quote.delete
      render={
        <DeleteModal
          destructive
          modalActivator={modalActivator}
          description={getTranslatedText(
            intl,
            'quote.details.delete.description'
          )}
          handleDeleteConfirmation={() => {
            handleDeleteQuote(quoteId);
          }}
          title={getTranslatedText(intl, 'quote.details.delete.title')}
        />
      }
    />
  );

  const getHeaderActionsForStatus = () => {
    if (props.restrictActions) {
      switch (data?.statusEnum) {
        case QUOTE_STATUS.PENDING.value:
          return (
            <Header>
              <ButtonGroup>
                <div className="unstyledLink">
                  {/* <UnstyledLink url={downloadDetails}> */}
                  <Button
                    loading={pdfDownloadLoading}
                    onClick={props.redirectUrl}
                    icon={<SVGIcon name="Download" />}
                  >
                    <FormattedMessage id="invoice.details.downloadPDF" />
                  </Button>
                  {/* </UnstyledLink> */}
                </div>
                <Button
                  loading={createQuoteLoading}
                  onClick={handleApprovalBeforeGeneration}
                  icon={<SVGIcon name="Check" color="black" />}
                >
                  <FormattedMessage id="quote.details.APPROVE" />
                </Button>
                <Button
                  onClick={handleRejectionBeforeRevision}
                  icon={<SVGIcon name="RejectedCircle" />}
                >
                  <FormattedMessage id="quote.details.REJECT" />
                </Button>
                <Button
                  onClick={() => {
                    window.open(`#/quoteList/${quoteId}/detail`).focus();
                  }}
                  icon={<SVGIcon name="RoleAndPermission" />}
                >
                  <FormattedMessage id="invoice.details.gotoPortal" />
                </Button>
              </ButtonGroup>
            </Header>
          );
        default:
          return (
            <Header>
              <ButtonGroup>
                <div className="unstyledLink">
                  {/* <UnstyledLink url={downloadDetails}> */}
                  <Button
                    loading={pdfDownloadLoading}
                    onClick={props.redirectUrl}
                    icon={<SVGIcon name="Download" />}
                  >
                    <FormattedMessage id="invoice.details.downloadPDF" />
                  </Button>
                  {/* </UnstyledLink> */}
                </div>

                <Button
                  onClick={() => {
                    window.open(`#/quoteList/${quoteId}/detail`).focus();
                  }}
                  icon={<SVGIcon name="RoleAndPermission" />}
                >
                  <FormattedMessage id="invoice.details.gotoPortal" />
                </Button>
              </ButtonGroup>
            </Header>
          );
      }
    }

    if (!isMSP) {
      switch (data?.statusEnum) {
        case QUOTE_STATUS.PENDING.value:
          return (
            <Header>
              <ButtonGroup>
                <div className="unstyledLink">
                  {/* <UnstyledLink url={downloadDetails}> */}
                  <Button
                    loading={pdfDownloadLoading}
                    onClick={pdfDownloadClick}
                    icon={<SVGIcon name="Download" />}
                  >
                    <FormattedMessage id="invoice.details.downloadPDF" />
                  </Button>
                  {/* </UnstyledLink> */}
                </div>
                <AccessControl
                  roleToCheck="quoteApproval.allow"
                  render={
                    <Button
                      loading={createQuoteLoading}
                      onClick={handleApprovalBeforeGeneration}
                      icon={<SVGIcon name="Check" color="black" />}
                    >
                      <FormattedMessage id="quote.details.APPROVE" />
                    </Button>
                  }
                />
                <AccessControl
                  roleToCheck="quoteApproval.allow"
                  render={
                    <Button
                      onClick={handleRejectionBeforeRevision}
                      icon={<SVGIcon name="RejectedCircle" />}
                    >
                      <FormattedMessage id="quote.details.REJECT" />
                    </Button>
                  }
                />
              </ButtonGroup>
            </Header>
          );
        case QUOTE_STATUS.APPROVED.value:
          return (
            <Header>
              <Button
                loading={pdfDownloadLoading}
                onClick={pdfDownloadClick}
                icon={<SVGIcon name="Download" />}
              >
                <FormattedMessage id="invoice.details.downloadPDF" />
              </Button>
            </Header>
          );

        case QUOTE_STATUS.REJECTED.value:
          return (
            <Header>
              <Button
                loading={pdfDownloadLoading}
                onClick={pdfDownloadClick}
                icon={<SVGIcon name="Download" />}
              >
                <FormattedMessage id="invoice.details.downloadPDF" />
              </Button>
            </Header>
          );
        default:
          break;
      }
    }
    switch (data?.statusEnum) {
      case QUOTE_STATUS.DRAFT.value:
        return (
          <Header>
            <ButtonGroup>
              {quoteVersions?.getQuoteVersions?.length > 0 ? (
                <Button
                  plainSecondary
                  onClick={() => {
                    setShowVersionModal(true);
                  }}
                  icon={<SVGIcon name="EstimatedTime" />}
                >
                  <FormattedMessage id="quote.details.versionHistory" />
                </Button>
              ) : (
                ''
              )}
              <div className="unstyledLink">
                {/* <UnstyledLink url={downloadDetails}> */}
                <Button
                  loading={pdfDownloadLoading}
                  onClick={pdfDownloadClick}
                  icon={<SVGIcon name="Download" />}
                >
                  <FormattedMessage id="invoice.details.downloadPDF" />
                </Button>

                {/* </UnstyledLink> */}
              </div>
              {QuoteDeleteButton}
              <Button
                onClick={() => {
                  setCustomModal(true);
                }}
                icon={<SVGIcon name="ServiceCatalog" />}
              >
                <FormattedMessage id="invoice.actions.importFromServiceCatalog" />
              </Button>
              <AccessControl
                roleToCheck="quote.add"
                render={
                  <Button
                    loading={quoteUpdateLoading}
                    onClick={() => {
                      openSendEmailModal();
                    }}
                    primary
                    connectedDisclosure={{
                      actions: splitOptions.map((el) => {
                        return {
                          content: (
                            <div
                              onClick={() => {
                                handleUpdateQuote({ statusEnum: el.name });
                              }}
                            >
                              {el.content}
                            </div>
                          )
                        };
                      })
                    }}
                    icon={!quoteUpdateLoading && <SVGIcon name="SendWhite" />}
                  >
                    <FormattedMessage id="invoiceBuilder.actions.create.saveAndSend" />
                  </Button>
                }
              />
              <AccessControl
                roleToCheck="quote.add"
                render={
                  <Button
                    onClick={cloneQuote}
                    loading={createQuoteLoading}
                    icon={<SVGIcon name="Clone" />}
                  >
                    <FormattedMessage id="quote.details.clone" />
                  </Button>
                }
              />
            </ButtonGroup>
          </Header>
        );
      case QUOTE_STATUS.PENDING.value:
        return !props.restrictActions ? (
          <Header>
            <ButtonGroup>
              {quoteVersions?.getQuoteVersions?.length > 0 ? (
                <Button
                  plainSecondary
                  onClick={() => {
                    setShowVersionModal(true);
                  }}
                  icon={<SVGIcon name="EstimatedTime" />}
                >
                  <FormattedMessage id="quote.details.versionHistory" />
                </Button>
              ) : (
                ''
              )}
              <div className="unstyledLink">
                {/* <UnstyledLink url={downloadDetails}> */}
                <Button
                  loading={pdfDownloadLoading}
                  onClick={pdfDownloadClick}
                  icon={<SVGIcon name="Download" />}
                >
                  <FormattedMessage id="invoice.details.downloadPDF" />
                </Button>
                {/* </UnstyledLink> */}
              </div>

              {QuoteDeleteButton}
              <AccessControl
                roleToCheck="quote.edit"
                render={
                  <Button
                    loading={createQuoteLoading}
                    onClick={handleRejectionBeforeRevision}
                    icon={<SVGIcon name="RotateRefreshLoading" color="black" />}
                  >
                    <FormattedMessage id="quote.details.revise" />
                  </Button>
                }
              />
              <AccessControl
                roleToCheck="quote.edit"
                render={
                  <Button
                    onClick={handleApprovalBeforeGeneration}
                    primary
                    icon={<SVGIcon name="InvoiceLogo" />}
                    loading={createInvoiceLoading || invoiceTemplateLoading}
                  >
                    <FormattedMessage id="quote.details.generateInvoice" />
                  </Button>
                }
              />
              <AccessControl
                roleToCheck="quote.add"
                render={
                  <Button
                    onClick={cloneQuote}
                    loading={createQuoteLoading}
                    icon={<SVGIcon name="Clone" />}
                  >
                    <FormattedMessage id="quote.details.clone" />
                  </Button>
                }
              />
            </ButtonGroup>
          </Header>
        ) : (
          ''
        );
      case QUOTE_STATUS.APPROVED.value:
        return (
          <Header>
            <ButtonGroup>
              {quoteVersions?.getQuoteVersions?.length > 0 ? (
                <Button
                  plainSecondary
                  onClick={() => {
                    setShowVersionModal(true);
                  }}
                  icon={<SVGIcon name="EstimatedTime" />}
                >
                  <FormattedMessage id="quote.details.versionHistory" />
                </Button>
              ) : (
                ''
              )}
              <div className="unstyledLink">
                {/* <UnstyledLink url={downloadDetails}> */}
                <Button
                  loading={pdfDownloadLoading}
                  onClick={pdfDownloadClick}
                  icon={<SVGIcon name="Download" />}
                >
                  <FormattedMessage id="invoice.details.downloadPDF" />
                </Button>
                {/* </UnstyledLink> */}
              </div>
              {!data?.invoice && isEditAuthorised && (
                <Button
                  onClick={() => {
                    handleInvoiceGeneration();
                  }}
                  primary
                  loading={createInvoiceLoading || invoiceTemplateLoading}
                  icon={<SVGIcon name="InvoiceLogo" />}
                >
                  <FormattedMessage id="quote.details.generateInvoice" />
                </Button>
              )}
              <AccessControl
                roleToCheck="quote.add"
                render={
                  <Button
                    onClick={cloneQuote}
                    loading={createQuoteLoading}
                    icon={<SVGIcon name="Clone" />}
                  >
                    <FormattedMessage id="quote.details.clone" />
                  </Button>
                }
              />
            </ButtonGroup>
          </Header>
        );
      case QUOTE_STATUS.REJECTED.value:
        return (
          <Header>
            <ButtonGroup>
              {quoteVersions?.getQuoteVersions?.length > 0 ? (
                <Button
                  plainSecondary
                  onClick={() => {
                    setShowVersionModal(true);
                  }}
                  icon={<SVGIcon name="EstimatedTime" />}
                >
                  <FormattedMessage id="quote.details.versionHistory" />
                </Button>
              ) : (
                ''
              )}
              <div className="unstyledLink">
                {/* <UnstyledLink url={downloadDetails}> */}
                <Button
                  loading={pdfDownloadLoading}
                  onClick={pdfDownloadClick}
                  icon={<SVGIcon name="Download" />}
                >
                  <FormattedMessage id="invoice.details.downloadPDF" />
                </Button>

                {/* </UnstyledLink> */}
              </div>
              {QuoteDeleteButton}
              <AccessControl
                roleToCheck="quote.edit"
                render={
                  <Button
                    loading={createQuoteLoading}
                    onClick={handleReviseQuote}
                    icon={<SVGIcon name="RotateRefreshLoading" color="black" />}
                  >
                    <FormattedMessage id="quote.details.revise" />
                  </Button>
                }
              />
              <AccessControl
                roleToCheck="quote.add"
                render={
                  <Button
                    onClick={cloneQuote}
                    loading={createQuoteLoading}
                    icon={<SVGIcon name="Clone" />}
                  >
                    <FormattedMessage id="quote.details.clone" />
                  </Button>
                }
              />
            </ButtonGroup>
          </Header>
        );
      case QUOTE_STATUS.EXPIRED.value:
        return (
          <Header>
            <ButtonGroup>
              {quoteVersions?.getQuoteVersions?.length > 0 ? (
                <Button
                  plainSecondary
                  onClick={() => {
                    setShowVersionModal(true);
                  }}
                  icon={<SVGIcon name="EstimatedTime" />}
                >
                  <FormattedMessage id="quote.details.versionHistory" />
                </Button>
              ) : (
                ''
              )}
              <div className="unstyledLink">
                {/* <UnstyledLink url={downloadDetails}> */}
                <Button
                  loading={pdfDownloadLoading}
                  onClick={pdfDownloadClick}
                  icon={<SVGIcon name="Download" />}
                >
                  <FormattedMessage id="invoice.details.downloadPDF" />
                </Button>
                {/* </UnstyledLink> */}
              </div>
              {QuoteDeleteButton}
              <AccessControl
                roleToCheck="quote.add"
                render={
                  <Button
                    onClick={cloneQuote}
                    loading={createQuoteLoading}
                    icon={<SVGIcon name="Clone" />}
                  >
                    <FormattedMessage id="quote.details.clone" />
                  </Button>
                }
              />
            </ButtonGroup>
          </Header>
        );
      default:
        return '';
    }
  };
  const updateState = (section, state) => {
    switch (section) {
      case 'showCc':
        setShowCc(state);
        break;
      case 'showBcc':
        setShowBcc(state);
        break;
      default:
    }
  };

  const sendContent = (content) => {
    const inputParams = pick(content, [
      'content',
      'toUsers',
      'ccUsers',
      'bccUsers',
      'attachments',
      'subject',
      'inlineImages',
      'conversationId'
    ]);
    //taking the parent conversation object
    const parentConversation =
      quoteEvents?.getQuoteEvents?.events?.find(
        (el) =>
          el?.eventType === 'CONVERSATION' &&
          !el?.conversation?.parentConversationId
      )?.conversation || null;
    handleUpdateQuote({
      conversation: {
        ...inputParams,
        parentConversationId: parentConversation
          ? parentConversation.conversationId
          : undefined
      },
      statusEnum: QUOTE_STATUS.PENDING.value
    });
  };

  function generateFieldData({
    editmode,
    entity,
    field: fieldData,
    isInactive
  }) {
    // let isEditAuthorised = false;

    const attributes = getEntityAttributes(allEntities, entity);

    const field = attributes?.find((f) => f.name === fieldData?.fieldName);

    if (!field) {
      return null;
    }

    switch (field.name) {
      case 'displayId':
        return (
          <div className="flex center">
            <span>{getTranslatedText(intl, 'quote.details.heading')}</span>
            <span className="ml8">
              <B1>{`#${data.displayId}`}</B1>
            </span>
          </div>
        );
      case 'quoteDate':
        return (
          <div className="flex center lh-30">
            <FormattedMessage id="quote.details.quoteDate" /> :{' '}
            {editmode ? (
              <DateTimePicker
                selected={data.quoteDate && dayjs(data.quoteDate).toDate()}
                onChange={(value) =>
                  modifyData({
                    properties: {
                      quoteDate: dayjs(value).format('YYYY-MM-DD')
                    }
                  })
                }
                placeholderText={getTranslatedText(
                  intl,
                  'quote.details.quoteDate.placeholder'
                )}
                required
                disabled={false}
                popperPlacement="auto"
              />
            ) : (
              <span className="ml8">
                <TextStyle weight="SemiBold">
                  <DateTimeFormatter
                    type="date"
                    // date={dayjs().format('YYYY-MM-DD')}
                    date={data.quoteDate}
                  />
                </TextStyle>
                {/* {`${data.invoiceDate}`} */}
              </span>
            )}
          </div>
        );
      case 'expiryDate':
        return (
          <>
            <div className="flex center lh-30">
              <FormattedMessage id="quote.details.expiryDate" /> :{' '}
              {editmode ? (
                <DateTimePicker
                  selected={data.expiryDate && dayjs(data.expiryDate).toDate()}
                  onChange={(value) =>
                    modifyData({
                      properties: {
                        expiryDate: dayjs(value).format('YYYY-MM-DD')
                      }
                    })
                  }
                  placeholderText={getTranslatedText(
                    intl,
                    'quote.details.expiryDate.placeholder'
                  )}
                  required
                  disabled={false}
                  popperPlacement="auto"
                />
              ) : (
                <span className="ml8">
                  <TextStyle weight="SemiBold">
                    {data.expiryDate ? (
                      <DateTimeFormatter
                        type="date"
                        // date={dayjs().format('YYYY-MM-DD')}
                        date={data.expiryDate}
                      />
                    ) : (
                      'NA'
                    )}
                  </TextStyle>
                </span>
              )}
            </div>

            {!!errors?.expiryDate?.[0] && (
              <div className="flex actr mt8">
                <SVGIcon name="InlineError" color="#e02020" />
                <span className="ml-5 danger">{errors?.expiryDate?.[0]}</span>
              </div>
            )}
          </>
        );
      default:
        const displayValue =
          entity === 'Client'
            ? data?.client?.customFields?.[field?.name] || ''
            : data?.customFields?.[field?.name] || '';

        // if (isInactive && !displayValue) {
        //   return null;
        // }

        // if (field?.entity === 'Quote') {
        //   isEditAuthorised = isQuoteCustomFieldsAuthorised;
        // }
        // if (field?.entity === 'Client') {
        //   isEditAuthorised = isClientCustomFieldsAuthorised;
        // }

        return (
          <div className="flex center lh-30">
            <FormattedMessage id={field?.label || `attribute.${field?.name}`} />
            :{' '}
            {editmode && fieldData?.entity !== 'Client' ? (
              <TextField
                type="text"
                key={`${field?.name}-${fieldData?.entity}-input`}
                value={displayValue}
                onChange={(val) => {
                  modifyData({
                    properties: {
                      customFields: {
                        ...data?.customFields,
                        [field?.name]: val
                      }
                    }
                  });
                }}
                disabled={!!isInactive}
                label={field?.label || `attribute.${field?.name}`}
                labelHidden
              />
            ) : (
              <span className="ml8">
                {displayValue || (
                  <DisabledTag>
                    <FormattedMessage id="app.noData.message" />
                  </DisabledTag>
                )}
              </span>
            )}
          </div>
        );
    }
  }

  const isSideConversationAvailable = useCheckFeatureGating(
    'SIDE_CONVERSATIONS'
  )?.enabled;

  const showConversationsTab = () => {
    if (isMSP) {
      if (isSideConversationAvailable) {
        return !props.restrictActions;
      }
      return (
        quoteEvents?.getQuoteEvents?.events?.length > 0 &&
        !props.restrictActions
      );
    }
    return (
      quoteEvents?.getQuoteEvents?.events?.length > 0 &&
      !props.restrictActions &&
      isConversationViewAuthorised
    );
  };

  let quoteIdSideConversation = quoteId;
  if (quoteVersions?.getQuoteVersions?.length > 0) {
    const versions = quoteVersions?.getQuoteVersions;
    quoteIdSideConversation = versions[versions.length - 1].quoteId;
  }

  return (
    <SizeMe monitorHeight monitorWidth>
      {({ size }) => {
        const isLargeScreen = size?.width > 1800;
        const isVeryLargeScreen = size?.width > 2500;
        const isSmallScreen = document?.documentElement?.clientWidth < 900;
        return (
          <div className={`full-height ${isSmallScreen ? 'full-width' : ''}`}>
            <PageHeader
              className="flex center bg-white"
              restrictActions={props.restrictActions}
            >
              {!props.restrictActions && (
                <Heading>
                  <div className="flex center g10">
                    <QuoteLogo className="flex actr jctr">
                      <SVGIcon name="QuoteModule" size="xl" />
                    </QuoteLogo>
                    <div className="flex fcol">
                      <B1 className="invoice-page-heading">
                        <FormattedMessage id="quote.details.heading" />
                      </B1>
                      {data?.invoice && (
                        <Button
                          plain
                          disabled={!isInvoiceViewAuthorised}
                          onClick={() => {
                            tabContext.openTab({
                              module: 'INVOICE',
                              data: {
                                invoiceId: data.invoice.invoiceId,
                                displayId: data.invoice.displayId
                              }
                            });
                          }}
                        >
                          <div className="flex g10 center mt-5">
                            <FormattedMessage id="invoice.name.placeholder" />
                            <div>{`#${data?.invoice?.displayId}`}</div>
                          </div>
                        </Button>
                      )}
                    </div>
                  </div>
                </Heading>
              )}
              {!props.restrictActions && (
                <div className="mlauto flex center">
                  {/* {!isLargeScreen && showConversationsTab() && (
                    <div className="mr10">
                      <Button
                        onClick={toggleSheetActive}
                        icon={<SVGIcon name="Conversation" />}
                      />
                    </div>
                  )} */}
                  {getHeaderActionsForStatus()}
                </div>
              )}
              <FixedPositionActionsGroup
                position={{
                  top: 200
                }}
                actions={[
                  {
                    name: 'quote.details.conversations',
                    icon: 'Conversation',
                    onClick: () => toggleSheetActive('Conversation'),
                    visible: showConversationsTab() && !isLargeScreen
                  },
                  {
                    name: 'client.new.additional.label',
                    icon: 'CollapseRight',
                    onClick: () => toggleSheetActive('AdditionalProperties'),
                    visible:
                      isQuoteCustomFieldsAuthorised &&
                      !props.restrictActions &&
                      !isVeryLargeScreen
                  }
                ].filter((action) => action.visible)}
              />
            </PageHeader>
            <ContentWrap
              className="flex center jcenter g20"
              restrictActions={props.restrictActions}
            >
              <Wrapper
                fullHeight
                contentPadding="20px 0"
                className={`full-height p20 full-width ${
                  isLargeScreen ? 'flex center jcenter full-width' : ''
                } ${isSmallScreen ? 'scroll' : ''}`}
                clicked={clicked}
                ref={(node) => {
                  if (!invoiceNode.current) {
                    invoiceNode.current = node;
                  }
                }}
                isChatVisible={
                  isLargeScreen &&
                  quoteEvents?.getQuoteEvents?.events?.length > 0 &&
                  isConversationViewAuthorised
                }
                isAdditionalPropertiesVisible={isVeryLargeScreen}
              >
                <div
                  className={`full-height white-grey-page g20 ${
                    isLargeScreen ? 'flex center mw-100' : ''
                  }`}
                >
                  <Page
                    variant="primary"
                    title={
                      <Header className="center w100">
                        {!editMode ? (
                          <div
                            className="invoice-title"
                            element="h1"
                            weight="bold"
                          >
                            {data.title || `Quote #${data.displayId}`}
                          </div>
                        ) : (
                          <InvoiceTitleEdit>
                            <div className="hidden-div" aria-hidden>
                              {data.title !== null
                                ? data.title
                                : `Quote #${data.displayId}`}
                            </div>
                            <TextField
                              placeholder={getTranslatedText(
                                intl,
                                'quote.details.title.placeholder'
                              )}
                              value={
                                data.title !== null
                                  ? data.title
                                  : `Quote #${data.displayId}`
                              }
                              onChange={(val) => {
                                updateTitle(val);
                              }}
                              maxLength={TEXT_LENGTH.size_5}
                              bgTransparent
                            />
                          </InvoiceTitleEdit>
                        )}
                        <div className="ml-10 ellipsis status-tag self-start flex actr">
                          <InvoiceStatusCell
                            cell={{
                              value: data.statusEnum,
                              row: { original: data }
                            }}
                            statusObj={QUOTE_STATUS}
                          />
                        </div>
                        {data.operationStatus === 'PROGRESS' && (
                          <ListInfoBanner message="invoice.details.regeneration.inProgress" />
                        )}
                      </Header>
                    }
                    primaryAction={
                      props.restrictActions ? (
                        <div>{getHeaderActionsForStatus()}</div>
                      ) : (
                        ''
                      )
                    }
                  >
                    {createQuoteLoading ? (
                      <CustomLoader type="REVISE_QUOTE" intl={intl} />
                    ) : (
                      <>
                        {!editMode ? (
                          <div
                            className="invoice-title mb20 content-padding"
                            element="h1"
                            weight="bold"
                          >
                            {data?.description}
                          </div>
                        ) : (
                          <PrimaryHeader>
                            <TextField
                              value={data?.description}
                              id="quoteDesc"
                              onChange={(val) => {
                                updateDescription(val);
                              }}
                              placeholder={getTranslatedText(
                                intl,
                                'quote.details.description'
                              )}
                              name="quoteDesc"
                              type="text"
                              error={errors?.description?.[0]}
                              // disabled={!isEditAuthorised}
                              maxLength={TEXT_LENGTH.size_5}
                            />
                          </PrimaryHeader>
                        )}
                        {notClient &&
                          allowPushToThirdParty &&
                          (data?.pushedToIntegratedAppError?.length > 0 ||
                            data?.pushPaymentToIntegratedAppError?.length >
                              0) && (
                            <div className="content-padding mb40">
                              <InvoiceErrors
                                integratedAppId={thirdPartyAppId}
                                paymentErrors={
                                  data.pushPaymentToIntegratedAppError || []
                                }
                                thirdPartyErrors={
                                  data.pushedToIntegratedAppError || []
                                }
                              />
                            </div>
                          )}
                        <ClientInfo className="grid g40 content-padding">
                          <div className="flex">
                            <div>
                              {mspConf?.hasOwnProperty('companylogo') ? (
                                mspConf?.companylogo && (
                                  <BrandingLogo alignVertical hideName />
                                )
                              ) : (
                                <BrandingLogo alignVertical hideName />
                              )}
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: dompurifier(
                                    sanitizeWhiteSpace(
                                      manipulatedData?.senderAddress
                                    )
                                  )
                                }}
                              />
                            </div>
                            <div className="mlauto flex center self-start">
                              {includes(
                                [
                                  QUOTE_STATUS.REJECTED.value,
                                  QUOTE_STATUS.APPROVED.value,
                                  QUOTE_STATUS.EXPIRED.value
                                ],
                                data.statusEnum
                              ) && (
                                <div>
                                  <BackgroundIcon
                                    className="mr-10"
                                    url={`url(${
                                      envConfig.imageRoot
                                    }svg/${data.statusEnum.toLowerCase()}.svg)`}
                                    height="100px"
                                    width="100px"
                                  />
                                </div>
                              )}
                              {entitiesLoading ? (
                                <Loader />
                              ) : (
                                <DateSection className="flex col aend">
                                  {invoiceSettings?.quoteTemplate?.preferences?.fieldSettings?.map(
                                    (field) => {
                                      return (
                                        <div
                                          key={`${field?.name}-${field?.entity}`}
                                        >
                                          {generateFieldData({
                                            editmode: editMode,
                                            key: field?.fieldName,
                                            field: field,
                                            entity: field?.entity,
                                            isInactive: inactiveFields?.includes(
                                              field?.fieldName
                                            )
                                          })}
                                        </div>
                                      );
                                    }
                                  )}

                                  {/* <div className="flex center">
                                    <span>
                                      {getTranslatedText(
                                        intl,
                                        'quote.details.heading'
                                      )}
                                    </span>
                                    <span className="ml8">
                                      <B1>{`#${data.displayId}`}</B1>
                                    </span>
                                  </div>
                                  <div className="flex center lh-30">
                                    <FormattedMessage id="quote.details.quoteDate" />{' '}
                                    :{' '}
                                    {editMode ? (
                                      <DateTimePicker
                                        selected={
                                          data.quoteDate &&
                                          dayjs(data.quoteDate).toDate()
                                        }
                                        onChange={(value) =>
                                          modifyData({
                                            properties: {
                                              quoteDate: dayjs(value).format(
                                                'YYYY-MM-DD'
                                              )
                                            }
                                          })
                                        }
                                        placeholderText={getTranslatedText(
                                          intl,
                                          'quote.details.quoteDate.placeholder'
                                        )}
                                        required
                                        disabled={false}
                                        popperPlacement="auto"
                                      />
                                    ) : (
                                      <span className="ml8">
                                        <TextStyle weight="SemiBold">
                                          <DateTimeFormatter
                                            type="date"
                                            // date={dayjs().format('YYYY-MM-DD')}
                                            date={data.quoteDate}
                                          />
                                        </TextStyle>
                                      </span>
                                    )}
                                  </div> */}
                                  {/* <div className="flex center lh-30">
                                    <FormattedMessage id="quote.details.expiryDate" />{' '}
                                    :{' '}
                                    {editMode ? (
                                      <DateTimePicker
                                        selected={
                                          data.expiryDate &&
                                          dayjs(data.expiryDate).toDate()
                                        }
                                        onChange={(value) =>
                                          modifyData({
                                            properties: {
                                              expiryDate: dayjs(value).format(
                                                'YYYY-MM-DD'
                                              )
                                            }
                                          })
                                        }
                                        placeholderText={getTranslatedText(
                                          intl,
                                          'quote.details.expiryDate.placeholder'
                                        )}
                                        required
                                        disabled={false}
                                        popperPlacement="auto"
                                      />
                                    ) : (
                                      <span className="ml8">
                                        <TextStyle weight="SemiBold">
                                          {data.expiryDate ? (
                                            <DateTimeFormatter
                                              type="date"
                                              // date={dayjs().format('YYYY-MM-DD')}
                                              date={data.expiryDate}
                                            />
                                          ) : (
                                            'NA'
                                          )}
                                        </TextStyle>
                                      </span>
                                    )}
                                  </div> */}
                                  {/* {!!errors?.expiryDate?.[0] && (
                                    <div className="flex actr mt8">
                                      <SVGIcon
                                        name="InlineError"
                                        color="#e02020"
                                      />
                                      <span className="ml-5 danger">
                                        {errors?.expiryDate?.[0]}
                                      </span>
                                    </div>
                                  )} */}
                                </DateSection>
                              )}
                            </div>
                          </div>
                          <div>
                            <B3T2 className="uppercase sub-header f-12">
                              <FormattedMessage id="invoice.details.billTo" />
                            </B3T2>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: dompurifier(
                                  sanitizeWhiteSpace(
                                    manipulatedData?.billingAddress
                                  )
                                )
                              }}
                            />
                          </div>
                        </ClientInfo>
                        {data.operationStatus !== 'PROGRESS' && (
                          <div className="mt40 content-padding">
                            <TableContainer>
                              <ContentDeciderContainer
                                isLoading={
                                  loading || !columnGroup[0]?.columns?.length
                                }
                                hasContent
                                fullHeight
                                mainContent={
                                  <TableView
                                    context={{ records: [] }}
                                    onDragEnd={(newOrderItems) => {
                                      setData(
                                        onRowItemDragEnd({
                                          newOrderItems,
                                          dataRef
                                        })
                                      );
                                    }}
                                    columns={columnGroup}
                                    data={sortItems(data?.items) || []}
                                    setData={setData}
                                    rowCount={10000}
                                    refreshTable={fetchViewData}
                                    listInfo={listInfo}
                                    pagination={false}
                                    pages={0}
                                    defaultColumnCells={defaultColumnCells}
                                    recordCount={listInfo.totalCount}
                                    activePage={listInfo.page || 0}
                                    isLoading={
                                      listLoading ||
                                      data.operationStatus === 'PROGRESS'
                                    }
                                    noBulkSelect
                                    fullHeight
                                    dark
                                    emptyState={{
                                      nodataImage: `${envConfig.imageRoot}svg/not-found.svg`,
                                      heading: getTranslatedText(
                                        intl,
                                        'invoice.list.noItems'
                                      ),
                                      description: ''
                                    }}
                                    alignStart
                                    checkRowHighlight={checkRowHighlight}
                                  />
                                  // <div>Coming soon...</div>
                                }
                                loadingContent={<TableLoading rows={15} />}
                                notFoundURL={`${envConfig.imageRoot}svg/not-found.svg`}
                              />
                            </TableContainer>
                          </div>
                        )}
                        {data.operationStatus === 'PROGRESS' && (
                          <SkeletonTableLoading />
                        )}
                        <div className="total-section mt-30 content-padding pb-100 pr-25 flex g20">
                          {data?.memo && !editMode && (
                            <div className="flex fg1">
                              <DisplayMemo className="mt10">
                                <TextField
                                  value={data?.memo}
                                  multiline
                                  disabled
                                  autoComplete="off"
                                />
                              </DisplayMemo>
                            </div>
                          )}
                          {editMode ? (
                            <MemoGetter className="mt10 flex fg1">
                              <TextField
                                placeholder={getTranslatedText(
                                  intl,
                                  'admin.invoiceTemplate.customisation.invoiceMessage.placeholder'
                                )}
                                value={data?.memo}
                                onChange={(val) => {
                                  updateMemo(val);
                                }}
                                multiline
                                // value={comments}
                                // onChange={(val) => {
                                //   handlePropChange('comments', val);
                                // }}
                                // disabled={!selectedItem}
                                // onBlur={() => {
                                //   handlePropertyChange('comments', comments);
                                // }}
                                autoComplete="off"
                                maxLength={TEXT_LENGTH.size_5}
                              />
                            </MemoGetter>
                          ) : (
                            ''
                          )}
                          <div className="mt10 mlauto mr8">
                            <div className="mt10 mlauto mr8 w700 f-16">
                              {rows.length > 0
                                ? rows.map((el, idx) => {
                                    return (
                                      <div
                                        className={`flex center mlauto line-height-35 text-medium ${
                                          idx === 0 ? 'dash-separator' : ''
                                        }`}
                                      >
                                        <div className="fg1 fb-25">
                                          {getPrefix(el)}
                                        </div>
                                        <div className="fg1 fb-25">
                                          {getLabel(el)}
                                        </div>
                                        <div className="fg1 fb-25">
                                          {getRate(el)}
                                        </div>
                                        <div className="flex jend pr-20 bold fg1 fb-25">
                                          {getValue(el)}
                                        </div>
                                      </div>
                                    );
                                  })
                                : ''}
                            </div>
                            <div className="flex mr8 p20 mt-30 bold f-20 mlauto rounded-2xl w400 card-surface-bg">
                              <div className="flex jend fb-50">
                                <FormattedMessage id="invoice.details.total" />
                              </div>
                              <div className="ml8 mlauto flex jend fb-50">
                                <CurrencyText value={grandTotal} />
                              </div>
                            </div>
                          </div>
                        </div>
                        {data.statusEnum === QUOTE_STATUS.APPROVED.value ? (
                          <div className="flex col aend mt-20 pr40">
                            <FormattedMessage id="quote.details.approvedBy" />
                            <SignatureDisplayContainer>
                              {data?.approverName}
                            </SignatureDisplayContainer>
                          </div>
                        ) : (
                          ''
                        )}
                        {data?.footer && !editMode ? (
                          <div className="mt-20 border-top-gray p20">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: dompurifier(data?.footer)
                              }}
                            ></div>
                          </div>
                        ) : (
                          ''
                        )}
                        {editMode && (
                          <div>
                            <EditorHolder>
                              <EmailEditor
                                template={data?.template}
                                updateTemplate={updateTemplate}
                                placeholder={getTranslatedText(
                                  intl,
                                  'admin.invoiceTemplate.customisation.footer.placeholder'
                                )}
                                module="INVOICE_TEMPLATE"
                                details={{
                                  operation: 'CREATE'
                                }}
                                isUploading={false}
                              />
                            </EditorHolder>
                          </div>
                        )}
                      </>
                    )}
                  </Page>

                  {showConversationsTab() && (
                    <ChatWrapper>
                      <ChatHolder
                        invoiceNode={invoiceNode}
                        data={data}
                        quoteId={quoteIdSideConversation}
                        toggleSheetActive={toggleSheetActive}
                        sheetActive={
                          sheetActive && activeSheetName === 'Conversation'
                        }
                        isLargeScreen={isLargeScreen}
                        allConversations={quoteEvents?.getQuoteEvents?.events}
                        quoteEventsLoading={quoteEventsLoading}
                        refetchQuoteEvents={refetchQuoteEvents}
                      />
                    </ChatWrapper>
                  )}

                  {isMSP && isQuoteCustomFieldsAuthorised && (
                    <AdditionalPropertiesHolder
                      mode={editMode ? 'edit' : 'view'}
                      filterFields={invoiceSettings?.quoteTemplate?.preferences?.fieldSettings?.map(
                        (field) => field?.fieldName
                      )}
                      customFieldsData={data?.customFields}
                      onChangeHandler={(properties) => {
                        console.log(properties, ' => properties');
                        const clonedData = cloneDeep(data);
                        const updatedata = {
                          ...clonedData,
                          customFields: {
                            ...clonedData?.customFields,
                            ...properties
                          }
                        };
                        setData(updatedata);
                      }}
                      toggleSheetActive={toggleSheetActive}
                      sheetActive={
                        sheetActive &&
                        activeSheetName === 'AdditionalProperties'
                      }
                      isLargeScreen={isVeryLargeScreen}
                    />
                  )}
                  {customModal && (
                    <CustomModal open={customModal} onClose={closeModal}>
                      <ItemsToInvoice
                        client={client}
                        updateProperties={updateProperties}
                        closeModal={closeModal}
                        invoiceData={data}
                        noAudit
                        taxExempted={!invoiceSettings?.taxable}
                      />
                    </CustomModal>
                  )}
                  {showVersionModal && (
                    <CustomModal
                      open={showVersionModal}
                      onClose={closeVersionModal}
                    >
                      <div className="vh95 w-vw95 rounded-2xl p20 bg-black">
                        <VersionContainer
                          versions={quoteVersions?.getQuoteVersions?.map(
                            (el) => ({
                              ...el,
                              client: {
                                ...el?.client,
                                customFields:
                                  clientCustomFieldsRef.current || []
                              }
                            })
                          )}
                          closeVersionModal={closeVersionModal}
                          clientCustomFields={clientCustomFieldsRef.current}
                        />
                      </div>
                    </CustomModal>
                  )}
                  {showSendEmailModal && (
                    <CustomModal
                      open={showSendEmailModal}
                      onClose={closeSendEmailModal}
                      zIndex={500}
                    >
                      <ContentVerification
                        quoteId={quoteId}
                        accountId={data?.client?.accountId}
                        sendContent={sendContent}
                        isLoading={saveActionLoading}
                        closeSendEmailModal={closeSendEmailModal}
                        hasVersions={
                          quoteVersions?.getQuoteVersions?.length > 0
                        }
                        //passing the parent conversation object
                        parentConversation={
                          quoteEvents?.getQuoteEvents?.events?.find(
                            (el) =>
                              el?.eventType === 'CONVERSATION' &&
                              !el?.conversation?.parentConversationId
                          )?.conversation || null
                        }
                      />
                    </CustomModal>
                  )}
                  {showRejectModal && (
                    <CustomModal
                      open={showRejectModal}
                      onClose={closeRejectModal}
                    >
                      <QuoteActionPopup
                        quoteId={quoteId}
                        client={data?.client}
                        handleSubmit={(params) => {
                          handleRejectionSubmit({ ...params, isMSP });
                        }}
                        closeRejectionModal={closeRejectModal}
                        meta={{
                          title: getTranslatedText(
                            intl,
                            'quote.actions.rejectQuote.title'
                          ),
                          commentsHeader: getTranslatedText(
                            intl,
                            'quote.actions.rejectQuote.commentsHeader'
                          ),
                          commentsPlaceholder: getTranslatedText(
                            intl,
                            'quote.actions.rejectQuote.commentsPlaceholder'
                          )
                        }}
                        isLoading={approvalLoading}
                        nonAuthenticated={props.restrictActions}
                        bannerInfo={
                          isMSP && data?.statusEnum === 'PENDING'
                            ? 'quote.pending.revision.info'
                            : ''
                        }
                        hideSignature
                      />
                    </CustomModal>
                  )}
                  {showApprovalModal && (
                    <CustomModal
                      open={showApprovalModal}
                      onClose={closeApprovalModal}
                    >
                      <QuoteActionPopup
                        quoteId={quoteId}
                        client={data?.client}
                        handleSubmit={(params) => {
                          handleApprovalSubmit({ ...params, isMSP });
                        }}
                        closeApprovalModal={closeApprovalModal}
                        meta={{
                          title: getTranslatedText(
                            intl,
                            'quote.actions.approveQuote.title'
                          ),
                          commentsHeader: getTranslatedText(
                            intl,
                            'quote.actions.approveQuote.commentsHeader'
                          ),
                          commentsPlaceholder: getTranslatedText(
                            intl,
                            'quote.actions.approveQuote.commentsPlaceholder'
                          )
                        }}
                        isLoading={approvalLoading}
                        nonAuthenticated={props.restrictActions}
                        bannerInfo={
                          isMSP && data?.statusEnum === 'PENDING'
                            ? 'quote.pending.invoice.info'
                            : ''
                        }
                      />
                    </CustomModal>
                  )}
                </div>
              </Wrapper>
            </ContentWrap>
          </div>
        );
      }}
    </SizeMe>
  );
}

function ChatHolder(props) {
  const {
    data,
    quoteId,
    sheetActive,
    toggleSheetActive,
    isLargeScreen,
    allConversations,
    quoteEventsLoading,
    refetchQuoteEvents
  } = props;
  if (!isLargeScreen) {
    return (
      <Sheet open={sheetActive} onClose={toggleSheetActive}>
        <SheetWrapper>
          <QuoteConversations
            quoteId={quoteId}
            conversations={allConversations}
            clientId={data?.client?.accountId}
            conversationInfo={data?.conversationInfo}
            allConversationsLoading={quoteEventsLoading}
            refetchQuoteEvents={refetchQuoteEvents}
          />
        </SheetWrapper>
      </Sheet>
    );
  }
  return (
    <QuoteConversations
      outsideSheet
      quoteId={quoteId}
      conversationIds={data?.conversationIds}
      clientId={data?.client?.accountId}
      conversations={allConversations}
      allConversationsLoading={quoteEventsLoading}
      refetchQuoteEvents={refetchQuoteEvents}
      conversationInfo={data?.conversationInfo}
    />
  );
}

function CustomLoader(props) {
  const { intl } = props;
  return (
    <div className="flex col center jcenter">
      <LoadingWrapper>
        <Loading />
      </LoadingWrapper>
      <FormattedMessage id="quote.revision.loading" />
    </div>
  );
}

export default injectIntl(withRouter(withLDConsumer()(QuoteDetailsContainer)));
